import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
import { withTheme } from 'emotion-theming';
import styled$1 from 'react-emotion';

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
	nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
	__proto__: null,
	caches: caches,
	css: css,
	cx: cx,
	flush: flush,
	getRegisteredStyles: getRegisteredStyles,
	hydrate: hydrate,
	injectGlobal: injectGlobal,
	keyframes: keyframes,
	merge: merge,
	sheet: sheet
});

var styled = createEmotionStyled(emotion, React);

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};

var getMediaQuery = function getMediaQuery(css, breakpoint) {
  return '@media (min-width: ' + breakpoint + ') { ' + css + ' }';
};

var breakpointAndUp = {};

var _loop = function _loop(_breakpoint2) {
  if (breakpoints[_breakpoint2] !== '0') {
    breakpointAndUp[_breakpoint2] = function (css) {
      return getMediaQuery(css, breakpoints[_breakpoint2]);
    };
  }
};

for (var _breakpoint2 in breakpoints) {
  _loop(_breakpoint2);
}

var theme = { baseFontSize: 16 }; //DEBTxCYBG pull this from theme component or global?
var baseSpacing = 8;

var spacingHelper = function spacingHelper(value) {
    var fontMultiple = value * baseSpacing;
    var rems = fontMultiple / theme.baseFontSize;
    return rems + 'rem';
};

var spacing = {
    EIGHTH: spacingHelper(0.125),
    QUARTER: spacingHelper(0.25),
    HALF: spacingHelper(0.5),
    THREE_QUARTERS: spacingHelper(0.75),
    SINGLE: spacingHelper(1),
    ONE_AND_QUARTER: spacingHelper(1.25),
    ONE_AND_HALF: spacingHelper(1.5),
    ONE_AND_THREE_QUARTERS: spacingHelper(1.75),
    DOUBLE: spacingHelper(2),
    TWO_AND_HALF: spacingHelper(2.5),
    TRIPLE: spacingHelper(3),
    THREE_AND_HALF: spacingHelper(3.5),
    QUADRUPLE: spacingHelper(4),
    QUINTUPLE: spacingHelper(5),
    SEXTUPLE: spacingHelper(6),
    SEPTUPLE: spacingHelper(7),
    OCTUPLE: spacingHelper(8),
    NONUPLE: spacingHelper(9),
    DECUPLE: spacingHelper(10)
};

var externalMarginRegular = '\n    margin-right: ' + spacing.DOUBLE + ';\n    margin-bottom: ' + spacing.DOUBLE + ';\n';

var internalPaddingShell = '\n    overflow: auto;\n    padding-bottom: ' + spacing.SINGLE + '; \n    padding-left: ' + spacing.DOUBLE + '; \n    padding-right: 0; \n    padding-top: ' + spacing.DOUBLE + ';\n    ' + breakpointAndUp.md1('\n        padding-left: ' + spacing.TRIPLE + ';\n        padding-right: ' + spacing.SINGLE + ';\n    ') + '\n';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var HSL_SLICE_START = 4;
var DEFAULT_AMOUNT = 5;

var hslAdjust = function hslAdjust(hslText) {
	var splitHSL = hslText.slice(HSL_SLICE_START, hslText.length - 1).split(',');

	var _splitHSL = slicedToArray(splitHSL, 3),
	    hueLabel = _splitHSL[0],
	    saturationLabel = _splitHSL[1],
	    lightnessLabel = _splitHSL[2];

	var hue = parseInt(hueLabel, 10);
	var saturation = parseInt(saturationLabel.slice(0, saturationLabel.length - 1), 10);
	var lightness = parseInt(lightnessLabel.slice(0, lightnessLabel.length - 1), 10);

	return {
		darken: function darken() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness - amount) + '%)';
		},
		lighten: function lighten() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + saturation + '%, ' + (lightness + amount) + '%)';
		},
		saturate: function saturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation + amount) + '%, ' + lightness + '%)';
		},
		desaturate: function desaturate() {
			var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_AMOUNT;
			return 'hsl(' + hue + ', ' + (saturation - amount) + '%, ' + lightness + '%)';
		}
	};
};

var _templateObject = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(121, 0, 202, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(121, 0, 202, 0);\n  }\n']),
    _templateObject2 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(248, 0, 0, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(248, 0, 0, 0);\n  }\n']),
    _templateObject3 = taggedTemplateLiteral(['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n'], ['\n  0% {\n    box-shadow: 0 0 0 0 rgba(0, 148, 211, 0.8);\n  }\n  100% {\n    box-shadow: 0 0 0 ', ' rgba(0, 148, 211, 0);\n  }\n']),
    _templateObject4 = taggedTemplateLiteral(['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n'], ['\n  0% {\n    opacity: 0;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n']),
    _templateObject5 = taggedTemplateLiteral(['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n'], ['\n  0% {\n    opacity: 1;\n  }\n  25% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n']),
    _templateObject6 = taggedTemplateLiteral(['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n'], ['\n  from {\n    fill: ', ';\n  }\n  to {\n    fill: ', ';\n  }\n']),
    _templateObject7 = taggedTemplateLiteral(['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n'], ['\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject8 = taggedTemplateLiteral(['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n'], ['\n  0% {\n    transform: scale(0.8);\n  }\n  65.5% {\n    transform: scale(1.03);\n  }\n  100% {\n    transform: scale(1);\n  }\n']);

var circularPulseB = keyframes(_templateObject, spacing.QUADRUPLE);

var circularPulseCB = keyframes(_templateObject2, spacing.QUADRUPLE);

var circularPulseYB = keyframes(_templateObject3, spacing.QUADRUPLE);

var fadeIn = keyframes(_templateObject4);

var fadeOut = keyframes(_templateObject5);

var iconPulse = function iconPulse(colour) {
  return keyframes(_templateObject6, colour, hslAdjust(colour).lighten(0.2));
};

var rotate = keyframes(_templateObject7);

var scaleFadeIn = keyframes(_templateObject8);

var animations = {
  circularPulseB: circularPulseB,
  circularPulseCB: circularPulseCB,
  circularPulseYB: circularPulseYB,
  fadeIn: fadeIn,
  fadeOut: fadeOut,
  iconPulse: iconPulse,
  rotate: rotate,
  scaleFadeIn: scaleFadeIn
};

var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(217,33%,38%)',
  blueLighter: 'hsl(210, 97%, 87%)',
  blueLightest: 'hsl(210, 100%, 95%)',
  green: 'hsl(135, 41%, 48%)',
  greenUpdated: 'hsl(67, 100%, 35%)',
  greenLighter: 'hsl(90, 53%, 70%)',
  greenLightest: 'hsl(90, 61%, 88%)',
  greenLightestUpdated: 'hsl(66, 75%, 75%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 45%)',
  grey: 'hsl(0, 0%, 60%)',
  greyUpdated: 'hsl(0, 0%, 55%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  greyLightestUpdated: 'hsl(0, 0%, 91%)',
  orange: 'hsl(29, 77%, 56%)',
  orangeUpdated: 'hsl(28, 100%, 54%)',
  orangeLighter: 'hsl(30, 45%, 89%)',
  orangeLightestUpdated: 'hsl(31, 100%, 63%)',
  red: 'hsl(360, 93%, 41%)',
  redUpdated: 'hsl(360, 91%, 46%)',
  redLighter: 'hsl(360, 97%, 77%)',
  redLightest: 'hsl(360, 60%, 96%)',
  redLightestUpdated: 'hsl(10, 94%, 80%)',
  yellowLighter: 'hsl(55, 92%, 69%)',
  yellowLightest: 'hsl(55, 100%, 88%)',
  white: 'hsl(0, 0%, 100%)',
  whiteOff: 'hsl(0, 0%, 95%)',
  pebble: 'hsl(210, 46%, 91%)'
};

var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLighter = generalPalette.blueLighter,
    blueLightest = generalPalette.blueLightest,
    green = generalPalette.green,
    greenUpdated = generalPalette.greenUpdated,
    greenLighter = generalPalette.greenLighter,
    greenFaint = generalPalette.greenFaint,
    greenLightest = generalPalette.greenLightest,
    greenLightestUpdated = generalPalette.greenLightestUpdated,
    greyUpdated = generalPalette.greyUpdated,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    greyLightestUpdated = generalPalette.greyLightestUpdated,
    orange = generalPalette.orange,
    orangeLighter = generalPalette.orangeLighter,
    red = generalPalette.red,
    redUpdated = generalPalette.redUpdated,
    redLighter = generalPalette.redLighter,
    redLightest = generalPalette.redLightest,
    redLightestUpdated = generalPalette.redLightestUpdated,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    yellowLighter = generalPalette.yellowLighter,
    yellowLightest = generalPalette.yellowLightest,
    white = generalPalette.white,
    whiteOff = generalPalette.whiteOff,
    pebble = generalPalette.pebble;


var colours = {
  generalPalette: {
    black: black,
    blue: blue,
    blueLighter: blueLighter,
    blueLightest: blueLightest,
    green: green,
    greenUpdated: greenUpdated,
    greenLighter: greenLighter,
    greenLightest: greenLightest,
    greenLightestUpdated: greenLightestUpdated,
    greenFaint: greenFaint,
    greyDarkest: greyDarkest,
    greyDarker: greyDarker,
    grey: grey,
    greyUpdated: greyUpdated,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    greyLightestUpdated: greyLightestUpdated,
    orange: orange,
    orangeLighter: orangeLighter,
    pebble: pebble,
    red: red,
    redUpdated: redUpdated,
    redLighter: yellowLightest,
    redLightest: redLightest,
    redLightestUpdated: redLightestUpdated,
    yellowLighter: yellowLighter,
    yellowLightest: yellowLightest,
    white: white,
    whiteOff: whiteOff
  },
  component: {
    background: white,
    backgroundDisabled: greyLightest,
    border: greyLightest,
    borderDisabled: greyDarkest,
    focusOutline: 'hsl(208, 59%, 60%)',
    hover: greyLightest,
    locked: greyDarker,
    modalBackdrop: black,
    shell: whiteOff,
    tableCell: 'hsl(0, 0%, 97%)',
    tableHeader: 'hsl(0, 0%, 94%)',
    navigationButtonDisabled: 'hsl(215, 8%, 58%)',
    frame: {
      active: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 0%, 85%),' + 'hsl(45, 0%, 85%) 28px, hsl(46, 0%, 95%) 28px, hsl(46, 0%, 95%) 56px)',
        content: 'hsl(45, 0%, 85%)',
        contentAlternate: 'hsl(46, 0%, 95%)'
      },
      bespoke: {
        background: 'repeating-linear-gradient(45deg, hsl(302, 44%, 70%), ' + 'hsl(302, 44%, 70%) 28px, hsl(302, 44%, 90%) 28px, hsl(302, 44%, 90%) 56px)',
        content: 'hsl(302, 44%, 70%)',
        contentAlternate: 'hsl(302, 44%, 90%)'
      },
      deprecated: {
        background: 'repeating-linear-gradient(45deg, hsl(45, 100%, 46%), ' + 'hsl(45, 100%, 46%) 28px, hsl(46, 100%, 64%) 28px, hsl(46, 100%, 64%) 56px)',
        content: 'hsl(45, 100%, 46%)',
        contentAlternate: 'hsl(46, 100%, 64%)'
      },
      draft: {
        background: 'repeating-linear-gradient(45deg, ' + blue + ', ' + (blue + ' 28px, hsl(205, 52%, 58%) 28px, hsl(205, 52%, 58%) 56px)'),
        content: blue,
        contentAlternate: 'hsl(205, 52%, 58%)'
      },
      outdated: {
        background: 'repeating-linear-gradient(45deg, hsl(269, 69%, 69%), ' + 'hsl(269, 69%, 69%) 28px, hsl(270, 69%, 79%) 28px, hsl(270, 69%, 79%) 56px)',
        content: 'hsl(269, 69%, 69%)',
        contentAlternate: 'hsl(270, 69%, 79%)'
      }
    }
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    secondaryBody: greyDarker,
    supplementaryBody: grey
  },
  utility: {
    error: red,
    errorUpdated: redUpdated,
    errorLighter: redLighter,
    errorLightest: redLightest,
    errorLightestUpdated: redLightestUpdated,
    guidance: blue,
    guidanceLighter: blueLighter,
    guidanceLightest: blueLightest,
    important: red,
    importantLighter: redLighter,
    importantLightest: redLightest,
    indicative: orange,
    information: blue,
    informationUpdated: greyUpdated,
    informationLightest: blueLightest,
    informationLightestUpdated: greyLightestUpdated,
    negative: red,
    positive: green,
    rememberLighter: yellowLighter,
    rememberLightest: yellowLightest,
    success: green,
    successUpdated: greenUpdated,
    successLighter: greenLighter,
    successLightest: greenLightest,
    successLightestUpdated: greenLightestUpdated,
    successDisabled: greenFaint,
    tip: green,
    tipLighter: greenLighter,
    tipLightest: greenLightest,
    warning: orange
  },
  state: {
    active: green,
    archived: greyLightest,
    inactive: red,
    notStarted: greyDarker,
    paused: blue,
    pending: orange
  }
};

/* Font size config: usage example ${fontSize('arran')} */

var fontConfig = {
	lewis: {
		xs1: { fontSize: 37, lineHeight: 1.189 },
		sm1: { fontSize: 37, lineHeight: 1.189 },
		md1: { fontSize: 45, lineHeight: 1.067 },
		lg1: { fontSize: 52, lineHeight: 1.154 },
		xl1: { fontSize: 52, lineHeight: 1.154 }
	},
	skye: {
		xs1: { fontSize: 32, lineHeight: 1.125 },
		sm1: { fontSize: 32, lineHeight: 1.125 },
		md1: { fontSize: 40, lineHeight: 1.1 },
		lg1: { fontSize: 45, lineHeight: 1.156 },
		xl1: { fontSize: 45, lineHeight: 1.156 }
	},
	shetland: {
		xs1: { fontSize: 29, lineHeight: 1.241 },
		sm1: { fontSize: 29, lineHeight: 1.241 },
		md1: { fontSize: 34, lineHeight: 1.176 },
		lg1: { fontSize: 39, lineHeight: 1.128 },
		xl1: { fontSize: 39, lineHeight: 1.128 }
	},
	mull: {
		xs1: { fontSize: 26, lineHeight: 1.231 },
		sm1: { fontSize: 26, lineHeight: 1.231 },
		md1: { fontSize: 29, lineHeight: 1.241 },
		lg1: { fontSize: 33, lineHeight: 1.212 },
		xl1: { fontSize: 33, lineHeight: 1.212 }
	},
	islay: {
		xs1: { fontSize: 23, lineHeight: 1.217 },
		sm1: { fontSize: 23, lineHeight: 1.217 },
		md1: { fontSize: 25, lineHeight: 1.28 },
		lg1: { fontSize: 28, lineHeight: 1.286 },
		xl1: { fontSize: 28, lineHeight: 1.286 }
	},
	orkney: {
		xs1: { fontSize: 20, lineHeight: 1.4 },
		sm1: { fontSize: 20, lineHeight: 1.4 },
		md1: { fontSize: 22, lineHeight: 1.273 },
		lg1: { fontSize: 25, lineHeight: 1.28 },
		xl1: { fontSize: 25, lineHeight: 1.28 }
	},
	arran: {
		xs1: { fontSize: 18, lineHeight: 1.333 },
		sm1: { fontSize: 18, lineHeight: 1.333 },
		md1: { fontSize: 19, lineHeight: 1.474 },
		lg1: { fontSize: 21, lineHeight: 1.333 },
		xl1: { fontSize: 21, lineHeight: 1.333 }
	},
	jura: {
		xs1: { fontSize: 16, lineHeight: 1.5 },
		sm1: { fontSize: 16, lineHeight: 1.5 },
		md1: { fontSize: 16, lineHeight: 1.5 },
		lg1: { fontSize: 18, lineHeight: 1.556 },
		xl1: { fontSize: 18, lineHeight: 1.556 }
	},
	uist: {
		xs1: { fontSize: 14, lineHeight: 1.429 },
		sm1: { fontSize: 14, lineHeight: 1.429 },
		md1: { fontSize: 14, lineHeight: 1.429 },
		lg1: { fontSize: 16, lineHeight: 1.5 },
		xl1: { fontSize: 16, lineHeight: 1.5 }
	},
	bute: {
		xs1: { fontSize: 12, lineHeight: 1.333 },
		sm1: { fontSize: 12, lineHeight: 1.333 },
		md1: { fontSize: 13, lineHeight: 1.538 },
		lg1: { fontSize: 13, lineHeight: 1.538 },
		xl1: { fontSize: 13, lineHeight: 1.538 }
	},
	cumbrae: {
		xs1: { fontSize: 11, lineHeight: 1.455 },
		sm1: { fontSize: 11, lineHeight: 1.455 },
		md1: { fontSize: 12, lineHeight: 1.333 },
		lg1: { fontSize: 12, lineHeight: 1.333 },
		xl1: { fontSize: 12, lineHeight: 1.333 }
	}
};

var generateSASS = function generateSASS(mqBreakpoint, size, lineHeight) {
	var styles = '';
	if (parseInt(mqBreakpoint) === 0) {
		styles = 'font-size: ' + size + 'px; line-height: ' + lineHeight + ';';
	} else {
		styles = '\n      @media (min-width: ' + mqBreakpoint + ') {\n        font-size: ' + size + 'px;\n        line-height: ' + lineHeight + ';\n      }\n    ';
	}
	return styles;
};

var fontSizes = {};

for (var fontSize in fontConfig) {
	if (fontConfig.hasOwnProperty(fontSize)) {
		var style = '';
		for (var breakpoint in fontConfig[fontSize]) {
			if (fontConfig[fontSize].hasOwnProperty(breakpoint)) {
				var _fontConfig$fontSize$ = fontConfig[fontSize][breakpoint],
				    size = _fontConfig$fontSize$.fontSize,
				    lineHeight = _fontConfig$fontSize$.lineHeight;

				style += generateSASS(breakpoints[breakpoint], size, lineHeight);
			}
		}
		fontSizes[fontSize] = style;
	}
}

var useFontSize = {

	of: {
		lewis: function lewis() {
			return fontSizes['lewis'];
		},
		skye: function skye() {
			return fontSizes['skye'];
		},
		shetland: function shetland() {
			return fontSizes['shetland'];
		},
		mull: function mull() {
			return fontSizes['mull'];
		},
		islay: function islay() {
			return fontSizes['islay'];
		},
		orkney: function orkney() {
			return fontSizes['orkney'];
		},
		arran: function arran() {
			return fontSizes['arran'];
		},
		jura: function jura() {
			return fontSizes['jura'];
		},
		uist: function uist() {
			return fontSizes['uist'];
		},
		bute: function bute() {
			return fontSizes['bute'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['cumbrae'];
		}
	},

	biggerThan: {
		lewis: function lewis() {
			throw new Error("lewis is the biggest font");
		},
		skye: function skye() {
			return fontSizes['lewis'];
		},
		shetland: function shetland() {
			return fontSizes['skye'];
		},
		mull: function mull() {
			return fontSizes['shetland'];
		},
		islay: function islay() {
			return fontSizes['mull'];
		},
		orkney: function orkney() {
			return fontSizes['islay'];
		},
		arran: function arran() {
			return fontSizes['orkney'];
		},
		jura: function jura() {
			return fontSizes['arran'];
		},
		uist: function uist() {
			return fontSizes['jura'];
		},
		bute: function bute() {
			return fontSizes['uist'];
		},
		cumbrae: function cumbrae() {
			return fontSizes['bute'];
		}
	},

	smallerThan: {
		lewis: function lewis() {
			return fontSizes['skye'];
		},
		skye: function skye() {
			return fontSizes['shetland'];
		},
		shetland: function shetland() {
			return fontSizes['mull'];
		},
		mull: function mull() {
			return fontSizes['islay'];
		},
		islay: function islay() {
			return fontSizes['orkney'];
		},
		orkney: function orkney() {
			return fontSizes['arran'];
		},
		arran: function arran() {
			return fontSizes['jura'];
		},
		jura: function jura() {
			return fontSizes['uist'];
		},
		uist: function uist() {
			return fontSizes['bute'];
		},
		bute: function bute() {
			return fontSizes['cumbrae'];
		},
		cumbrae: function cumbrae() {
			throw new Error("cumbrae is the smallest font");
		}
	}
};

var LIFE_CYCLE_STATUSES = {
	ACTIVE: 'active',
	BESPOKE: 'bespoke',
	DEPRECATED: 'deprecated',
	DRAFT: 'draft',
	OUTDATED: 'outdated'
};

var checkIsVariantDeprecatedFromPackageJson = function checkIsVariantDeprecatedFromPackageJson(packageJson, variant) {
	var deprecations = packageJson.deprecations;


	if (!deprecations) {
		return false;
	}

	var isDeprecated = false;
	deprecations.forEach(function (deprecationObj) {
		return deprecationObj.variants && deprecationObj.variants.forEach(function (deprecatedVariant) {
			if (deprecatedVariant === variant) {
				isDeprecated = true;
			}
		});
	});
	return isDeprecated;
};

var getComponentProminentStatusFromPackage = function getComponentProminentStatusFromPackage(packageJson, variant) {
	var isComponentDeprecated = packageJson['component-life-cycle'] === LIFE_CYCLE_STATUSES.DEPRECATED;
	var isVariantDeprecated = variant && checkIsVariantDeprecatedFromPackageJson(packageJson, variant);

	if (isComponentDeprecated || isVariantDeprecated) {
		return LIFE_CYCLE_STATUSES.DEPRECATED;
	}

	if (packageJson['is-bespoke']) {
		return LIFE_CYCLE_STATUSES.BESPOKE;
	}

	return packageJson['component-life-cycle'];
};

var addFullStop = function addFullStop(value) {
	return value.charAt(value.length - 1) === '.' ? value : value.replace(/([^.])$/, '$1.');
};

var capitaliseFirstLetter = function capitaliseFirstLetter(value) {
	return value.trim().charAt(0).toUpperCase() + value.trim().slice(1);
};

var WEE_WORDS = ['an', 'is', 'of', 'to'];

var capitaliseFirstLetterExceptWeeOnes = function capitaliseFirstLetterExceptWeeOnes(value) {
	if (WEE_WORDS.includes(value)) {
		return value;
	}

	return capitaliseFirstLetter(value);
};

var lowercaseFirstLetter = function lowercaseFirstLetter(value) {
	return value.charAt(0).toLowerCase() + value.slice(1);
};

var slugifyString = function slugifyString(name) {
	return ('' + name.toLowerCase()).replace(' ', '-');
};

var StringUtils = {
	addFullStop: addFullStop,
	capitaliseFirstLetter: capitaliseFirstLetter,
	capitaliseFirstLetterExceptWeeOnes: capitaliseFirstLetterExceptWeeOnes,
	lowercaseFirstLetter: lowercaseFirstLetter,
	slugifyString: slugifyString
};

var _templateObject$1 = taggedTemplateLiteral(['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledInternalStandardBody = styled('div')(_templateObject$1, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var InternalStandardBody = function InternalStandardBody(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    id = _ref.id,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledInternalStandardBody,
		{ isFlush: isFlush, id: id, 'data-test-id': dataTestId },
		children
	);
};

InternalStandardBody.propTypes = {
	/** Child content as node. Should be used to wrap bodies of textual content. This textual content
  * should contain appropriate HTML tagging and passing in orphan text child content should
  * be avoided. */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** A unique ID used to identify the element within the DOM. */
	id: PropTypes.string,
	/** Data attribute for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalStandardBody.defaultProps = {
	isFlush: false,
	'data-test-id': 'internal-standardbody'
};

var _templateObject$2 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n'], ['\n\tcolor: ', ';\n\tlist-style: none;\n\tmargin-left: ', ';\n\tmargin-bottom: 0;\n\tmargin-top: 0;\n\tpadding-left: ', ';\n\n\tul {\n\t\tpadding-left: ', ';\n\t}\n']),
    _templateObject2$1 = taggedTemplateLiteral(['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n'], ['\n\tmargin-bottom: ', ';\n\tposition: relative;\n\n\t:before {\n\t\tcontent: \'\';\n\t\tposition: absolute;\n\t\tleft: -26px;\n\t\ttop: 10px;\n\t\twidth: 8px;\n\t\theight: 8px;\n\t\tborder: 1px solid ', ';\n\t\tbackground-color: ', ';\n\t\tborder-radius: ', ';\n\t}\n']);

var StyledUL = styled('ul')(_templateObject$2, function (props) {
	return props.theme.colours.bodyText;
}, spacing.DOUBLE, spacing.TRIPLE, spacing.DOUBLE);

var BORDER_RADIUS_DIVIDER = 4;
var BORDER_RADIUS_REMAINDER = 3;

var StyledListItem = styled('li')(_templateObject2$1, spacing.SINGLE, colours.generalPalette.black, function (props) {
	return props.level % 2 > 0 ? colours.generalPalette.black : 'transparent';
}, function (props) {
	return props.level % BORDER_RADIUS_DIVIDER === BORDER_RADIUS_REMAINDER || props.level % BORDER_RADIUS_DIVIDER === 0 ? '0' : '100%';
});

var processItems = function processItems(items, level) {
	return items.map(function (item, index) {
		return Array.isArray(item) ? React.createElement(
			StyledUL,
			{ key: level + '.' + [index] },
			processItems(item, level + 1)
		) : React.createElement(
			StyledListItem,
			{ key: level + '.' + [index], level: level },
			React.createElement(
				InternalStandardBody,
				{ isFlush: true },
				React.createElement(
					'span',
					null,
					item
				)
			)
		);
	});
};

var InternalBulletList = function InternalBulletList(_ref) {
	var items = _ref.items;
	return items !== ( undefined) && React.createElement(
		StyledUL,
		null,
		processItems(items, 1)
	);
};

InternalBulletList.propTypes = {
	/** An array of strings for each item. Can include other arrays for sub items. */
	items: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.node, PropTypes.string])).isRequired
};

var getThemeIcon = function getThemeIcon(vmIcon, generalIcon) {
  return function (themeName) {
    return themeName === 'vm' ? vmIcon : generalIcon;
  };
};

var _extends$1 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends$1({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("title", null, "icon-triangleright-large"), React.createElement("path", { d: "M16 8L0 16V0" }));
});

var _extends$2 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$1(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$1(_ref, ["styles"]);

  return React.createElement("svg", _extends$2({ height: "16", viewBox: "0 0 96 96", width: "16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M13.75 1.849l68.847 45.515-67.217 47.89" }));
});

var getTriangleRightLarge = getThemeIcon(VMIcon, GenericIcon);

var _templateObject$3 = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n'], ['\n\tbox-sizing: border-box;\n\tmargin-left: 6px;\n\tmax-height: 0;\n\toverflow: hidden;\n\tpadding-left: ', ';\n\tposition: relative;\n\ttransition: all 0.15s;\n\t', ';\n\n\t', ' p:last-child {\n\t\tmargin-bottom: 0;\n\t}\n\n\t:after {\n\t\tbackground-color: ', ';\n\t\tborder-radius: 4px;\n\t\tcontent: \'\';\n\t\tdisplay: block;\n\t\theight: 100%;\n\t\tleft: 0;\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\twidth: 4px;\n\t}\n']),
    _templateObject2$2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tbackground: none;\n\tborder: none;\n\tcolor: ', ';\n\tdisplay: flex;\n\t', ';\n\tpadding: 0;\n\ttext-decoration: underline;\n\ttransition: margin 0.15s;\n\twidth: 100%;\n\tcursor: pointer;\n\n\t> svg {\n\t\tfill: ', ';\n\t\ttransition: transform 0.15s;\n\t}\n\n\t', ';\n\n\t.buttonLabel {\n\t\tdisplay: flex;\n\t\tmargin-left: ', 'px;\n\t\t', ';\n\n\t\t@media (max-width: ', ') {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t:focus {\n\t\tbox-shadow: none;\n\n\t\t.buttonLabel {\n\t\t\tborder-radius: ', ';\n\t\t\tbox-shadow: 0 0 0 2px ', ';\n\t\t\toutline: 0;\n\t\t}\n\t}\n']),
    _templateObject3$1 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']);

var StyledBodyContent = styled('div')(_templateObject$3, spacing.DOUBLE, function (props) {
	return props.isOpen ? '\n\t\t\t\tanimation: ' + animations.fadeIn + ' 0.7s linear;\n\t\t\t  ' : '\n\t\t\t\tanimation: ' + animations.fadeOut + ' 0.5s linear;\n\t\t\t  ';
}, function (props) {
	return props.isOpen && '\n\t\tmax-height: 4000px;\n\t\toverflow: visible;\n\t\tpadding-bottom: ' + spacing.SINGLE + ';\n\t\tpadding-left: ' + spacing.DOUBLE + ';\n\n\t';
}, function (props) {
	return props.panelColour;
});

var StyledButton = styled('button')(_templateObject2$2, function (props) {
	return props.panelColour;
}, useFontSize.of.jura, function (props) {
	return props.panelColour;
}, function (props) {
	return props.isOpen && !props.hasIconOverride && '\n\t\tmargin-bottom: ' + spacing.DOUBLE + ';\n\n\t\t> svg {\n\t\t\ttransform: rotate(90deg) !important;\n\t\t}\n\t';
}, function (props) {
	return props.isHeadingString ? '6' : '8';
}, function (props) {
	return props.isHeadingString && 'padding: 0 2px;';
}, breakpoints.md1, function (props) {
	return props.theme.borderRadius;
}, colours.component.focusOutline);

var StyledWrapper = styled('div')(_templateObject3$1, function (props) {
	return props.hasAdditionalMarginBottom && 'margin-bottom: ' + spacing.TRIPLE;
});

var InternalContentRevealPanel = function InternalContentRevealPanel(_ref) {
	var children = _ref.children,
	    hasAdditionalMarginBottom = _ref.hasAdditionalMarginBottom,
	    titleText = _ref.titleText,
	    icon = _ref.icon,
	    isOpen = _ref.isOpen,
	    onClick = _ref.onClick,
	    panelColour = _ref.panelColour,
	    theme = _ref.theme,
	    dataTestId = _ref['data-test-id'];

	var isHeadingString = typeof titleText === 'string';
	var ariaLabel = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') : 'content-reveal-panel';
	var TriangleRightLargeIcon = getTriangleRightLarge(theme.name);
	var hasIconOverride = icon !== undefined;
	var contentId = isHeadingString ? titleText.toLowerCase().replace(/\s+/g, '-') + '-content-id' : 'content-reveal-panel-id';
	return React.createElement(
		StyledWrapper,
		{ hasAdditionalMarginBottom: hasAdditionalMarginBottom },
		React.createElement(
			StyledButton,
			{
				'aria-labelledby': ariaLabel,
				isOpen: isOpen,
				hasIconOverride: hasIconOverride,
				onClick: onClick,
				panelColour: panelColour,
				type: 'button',
				'data-test-id': dataTestId + '-button',
				'aria-expanded': isOpen,
				'aria-controls': contentId
			},
			icon ? icon : React.createElement(TriangleRightLargeIcon, null),
			React.createElement(
				'div',
				{ className: 'buttonLabel' },
				isHeadingString ? React.createElement(
					InternalStandardBody,
					{ isFlush: true },
					React.createElement(
						'span',
						{ id: ariaLabel },
						titleText
					)
				) : titleText
			)
		),
		React.createElement(
			StyledBodyContent,
			{
				isOpen: isOpen,
				panelColour: panelColour,
				id: contentId,
				'data-test-id': dataTestId + '-content'
			},
			children
		)
	);
};

InternalContentRevealPanel.propTypes = {
	/** Content of the panel. */
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
	/** Adds additional margin bottom. */
	hasAdditionalMarginBottom: PropTypes.bool,
	/** Set to true to open panel. */
	isOpen: PropTypes.bool,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Sets panel colour. */
	panelColour: PropTypes.string.isRequired,
	/** Title text. */
	titleText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
	/** Optional icon  */
	icon: PropTypes.node,
	/** Data attribute targeting inner html button for automation test purposes. */
	'data-test-id': PropTypes.string
};

InternalContentRevealPanel.defaultProps = {
	hasAdditionalMarginBottom: false,
	isOpen: false,
	'data-test-id': 'content-reveal-panel'
};

var WrappedInternalContentRevealPanel = withTheme(InternalContentRevealPanel);

var _templateObject$4 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject2$3 = taggedTemplateLiteral(['\n\t', ';\n\tdisplay: ', ';\n'], ['\n\t', ';\n\tdisplay: ', ';\n']),
    _templateObject3$2 = taggedTemplateLiteral(['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n'], ['\n\tbackground-color: ', ';\n\tborder-radius: ', ';\n\tcolor: ', ';\n\theight: min-content;\n\tdisplay: block;\n\tpadding: 0 ', ';\n\tfont-size: 14px;\n']),
    _templateObject4$1 = taggedTemplateLiteral(['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n'], ['\n\talign-items: flex-end;\n\tbackground: ', ';\n\tdisplay: flex;\n\tpadding: ', ';\n\tmargin-bottom: ', ';\n\n\t& > div {\n\t\tmargin-bottom: 0;\n\t}\n\n\tbutton {\n\t\ttext-decoration: none;\n\t}\n\n\tul {\n\t\tmargin-bottom: ', ';\n\t\tmargin-right: ', ';\n\t\tpadding-left: 0;\n\t\tpadding-top: ', ';\n\n\t\tli {\n\t\t\tcolor: ', ';\n\t\t\ttransform: scale(0.8);\n\t\t}\n\t}\n']),
    _templateObject5$1 = taggedTemplateLiteral(['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n'], ['\n\tpadding-top: ', ';\n\n\tp {\n\t\tcolor: ', ';\n\t\tmargin-bottom: ', ';\n\t}\n']),
    _templateObject6$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n'], ['\n\tbackground: ', ';\n\toverflow: auto;\n\tpadding: ', ';\n']);

var BasicBlockWrapper = styled('div')(_templateObject$4, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
});

var BasicInlineWrapper = styled('span')(_templateObject2$3, function (props) {
	return !props.removeFrameMargins && externalMarginRegular;
}, function (props) {
	return props.isInlineBlock ? 'inline-block' : 'inline';
});

var BasicDetails = styled('span')(_templateObject3$2, function (props) {
	return props.content;
}, spacing.HALF, colours.generalPalette.black, spacing.QUARTER);

var InfoContainer = styled('div')(_templateObject4$1, function (props) {
	return props.content;
}, spacing.SINGLE, spacing.SINGLE, spacing.DOUBLE, spacing.DOUBLE, spacing.SINGLE, colours.generalPalette.black);

var InfoContentWrapper = styled('div')(_templateObject5$1, spacing.SINGLE, colours.generalPalette.black, spacing.SINGLE);

var InnerComponentWrapper = styled('div')(_templateObject$4, function (props) {
	return props.isContainer && '\n\t\tbackground-color: hsla(0, 100%, 100%, 60%);\n\t\tpadding: ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE + ';\n\t';
});

var XRayComponentWrapper = styled('div')(_templateObject6$1, function (props) {
	return props.background;
}, function (props) {
	return props.isContainer ? '0' : spacing.SINGLE + ' ' + spacing.DOUBLE + ' ' + spacing.DOUBLE + ' ' + spacing.SINGLE;
});

var revealContent = {
	active: React.createElement(
		'span',
		null,
		'Details on this component can be found in the Web UI Components the style guide.'
	),
	bespoke: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component was built for a certainuse case and should not be used outside of that.'
		),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		)
	),
	deprecated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Deprecated components are no longer tested via:'
		),
		React.createElement(InternalBulletList, {
			items: ['Visual regression & brand testing.', 'Integration testing.', 'Manual input testing.', 'Accessibility testing.']
		}),
		React.createElement(
			'p',
			null,
			'Further details can be found in the Web UI Components style guide.'
		),
		React.createElement(
			'p',
			null,
			React.createElement(
				'b',
				null,
				React.createElement(
					'u',
					null,
					'Upgrade as soon as possible.'
				)
			)
		)
	),
	draft: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'Do not log defects for:'
		),
		React.createElement(InternalBulletList, {
			items: ['Appearance or styles.', 'Keyboard or mouse behaviours.', 'Missing input validations.'],
			isFlush: true
		}),
		React.createElement(
			'p',
			null,
			'Upgrade before using in production.'
		)
	),
	outdated: React.createElement(
		'span',
		null,
		React.createElement(
			'p',
			null,
			'This component is outdated. Therefore, should not be used in newer project work.'
		),
		React.createElement(
			'p',
			null,
			'It may have issues with:'
		),
		React.createElement(InternalBulletList, { items: ['Accessibility.', 'Consistency.', 'Optimisation.'], isFlush: true }),
		React.createElement(
			'p',
			null,
			'Before adding to a new codebase, contact the UI team about seeking a replacement.'
		)
	)
};

var getComponentName = function getComponentName(packageJson) {
	return packageJson.main.split('.')[0];
};

var InternalComponentFrame = function (_Component) {
	inherits(InternalComponentFrame, _Component);

	function InternalComponentFrame(props) {
		classCallCheck(this, InternalComponentFrame);

		var _this = possibleConstructorReturn(this, (InternalComponentFrame.__proto__ || Object.getPrototypeOf(InternalComponentFrame)).call(this, props));

		_this.state = {
			isOpen: false
		};
		return _this;
	}

	createClass(InternalComponentFrame, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			// eslint-disable-next-line react/prop-types
			var _props = this.props,
			    children = _props.children,
			    hasCustomMargins = _props.hasCustomMargins,
			    layout = _props.layout,
			    isFlush = _props.isFlush,
			    packageJson = _props.packageJson,
			    variant = _props.variant,
			    xraySuppressed = _props.xraySuppressed;
			var isOpen = this.state.isOpen;
			var _window = window,
			    XrayHelper = _window.XrayHelper;


			var componentName = getComponentName(packageJson);
			var status = getComponentProminentStatusFromPackage(packageJson, variant);
			var formattedStatus = StringUtils.capitaliseFirstLetter(status);
			var variantSuffix = variant ? '.' + variant : '';

			var isContainer = layout === 'container';
			var isInline = layout === 'inline-block' || layout === 'inline';
			var isTypography = layout === 'typography';
			var isCompactLayout = isInline || isTypography;
			var _colours$component$fr = colours.component.frame[status],
			    background = _colours$component$fr.background,
			    content = _colours$component$fr.content;


			if (xraySuppressed || XrayHelper && XrayHelper.checkIsXrayMode() === false) {
				return isInline ? React.createElement(
					BasicInlineWrapper,
					{ isInlineBlock: layout === 'inline-block', removeFrameMargins: hasCustomMargins || isFlush },
					children
				) : React.createElement(
					BasicBlockWrapper,
					{ removeFrameMargins: hasCustomMargins || isFlush },
					children
				);
			}

			return isCompactLayout ? React.createElement(
				'div',
				null,
				children,
				React.createElement(
					BasicDetails,
					{ content: content },
					React.createElement(
						'b',
						null,
						formattedStatus,
						' component:'
					),
					' ',
					componentName,
					variantSuffix
				)
			) : React.createElement(
				'div',
				null,
				React.createElement(
					XRayComponentWrapper,
					{ background: background, isContainer: isContainer },
					React.createElement(
						InnerComponentWrapper,
						{ isContainer: isContainer },
						children
					)
				),
				React.createElement(
					InfoContainer,
					{ content: content },
					React.createElement(
						WrappedInternalContentRevealPanel,
						{
							panelColour: 'black',
							titleText: formattedStatus + ' component: ' + getComponentName(packageJson) + variantSuffix,
							isOpen: isOpen,
							onClick: function onClick() {
								return _this2.setState(function (prevState) {
									return { isOpen: !prevState.isOpen };
								});
							}
						},
						React.createElement(
							InfoContentWrapper,
							null,
							revealContent[status]
						)
					)
				)
			);
		}
	}]);
	return InternalComponentFrame;
}(Component);

InternalComponentFrame.propTypes = {
	children: PropTypes.node.isRequired,
	hasCustomMargins: PropTypes.bool,
	isFlush: PropTypes.bool,
	layout: PropTypes.oneOf(['block', 'container', 'inline', 'inline-block', 'typography']),
	packageJson: PropTypes.object.isRequired,
	variant: PropTypes.string,
	xraySuppressed: PropTypes.bool
};

InternalComponentFrame.defaultProps = {
	hasCustomMargins: false,
	isFlush: false,
	layout: 'block',
	xraySuppressed: false
};

var componentPaths = [
	{
		name: "ActionAnchor",
		path: "actions/anchors/ActionAnchor",
		styleguidePath: "Actions/Anchors/ActionAnchor",
		importPath: "web-ui-components/lib/actions/anchors"
	},
	{
		name: "ActionButton",
		path: "actions/buttons/ActionButton",
		styleguidePath: "Actions/Buttons/ActionButton",
		importPath: "web-ui-components/lib/actions/buttons"
	},
	{
		name: "SwitchButton",
		path: "actions/buttons/SwitchButton",
		styleguidePath: "Actions/Buttons/SwitchButton",
		importPath: "web-ui-components/lib/actions/buttons"
	},
	{
		name: "EmailLink",
		path: "actions/links/EmailLink",
		styleguidePath: "Actions/Links/EmailLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "PhoneLink",
		path: "actions/links/PhoneLink",
		styleguidePath: "Actions/Links/PhoneLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "WebsiteLink",
		path: "actions/links/WebsiteLink",
		styleguidePath: "Actions/Links/WebsiteLink",
		importPath: "web-ui-components/lib/actions/links"
	},
	{
		name: "InputRadio",
		path: "actions/radios/InputRadio",
		styleguidePath: "Actions/Radios/InputRadio",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "InputRadioGroup",
		path: "actions/radios/InputRadioGroup",
		styleguidePath: "Actions/Radios/InputRadioGroup",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "TallRadioCard",
		path: "actions/radios/TallRadioCard",
		styleguidePath: "Actions/Radios/TallRadioCard",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "WideRadioCard",
		path: "actions/radios/WideRadioCard",
		styleguidePath: "Actions/Radios/WideRadioCard",
		importPath: "web-ui-components/lib/actions/radios"
	},
	{
		name: "NewWindowAction",
		path: "advisor/actions/NewWindowAction",
		styleguidePath: "Advisor/Actions/NewWindowAction",
		importPath: "web-ui-components/lib/advisor/actions"
	},
	{
		name: "CustomerAlert",
		path: "advisor/alerts/CustomerAlert",
		styleguidePath: "Advisor/Alerts/CustomerAlert",
		importPath: "web-ui-components/lib/advisor/alerts"
	},
	{
		name: "ClickableContentFrame",
		path: "advisor/layout/ClickableContentFrame",
		styleguidePath: "Advisor/Layout/ClickableContentFrame",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "DashboardGrid",
		path: "advisor/layout/DashboardGrid",
		styleguidePath: "Advisor/Layout/DashboardGrid",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "WideModal",
		path: "advisor/layout/WideModal",
		styleguidePath: "Advisor/Layout/WideModal",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "WindowFrame",
		path: "advisor/layout/WindowFrame",
		styleguidePath: "Advisor/Layout/WindowFrame",
		importPath: "web-ui-components/lib/advisor/layout"
	},
	{
		name: "ProductRadioCard",
		path: "advisor/radios/ProductRadioCard",
		styleguidePath: "Advisor/Radios/ProductRadioCard",
		importPath: "web-ui-components/lib/advisor/radios"
	},
	{
		name: "AccountSelect",
		path: "advisor/selects/AccountSelect",
		styleguidePath: "Advisor/Selects/AccountSelect",
		importPath: "web-ui-components/lib/advisor/selects"
	},
	{
		name: "SessionTimeoutTakeover",
		path: "advisor/takeovers/SessionTimeoutTakeover",
		styleguidePath: "Advisor/Takeovers/SessionTimeoutTakeover",
		importPath: "web-ui-components/lib/advisor/takeovers"
	},
	{
		name: "Anchor",
		path: "atoms/buttons/Anchor",
		styleguidePath: "Atoms/Buttons/Anchor",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "Button",
		path: "atoms/buttons/Button",
		styleguidePath: "Atoms/Buttons/Button",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "ButtonTitle",
		path: "atoms/buttons/ButtonTitle",
		styleguidePath: "Atoms/Buttons/ButtonTitle",
		importPath: "web-ui-components/lib/atoms/buttons"
	},
	{
		name: "Calendar",
		path: "atoms/forms/Calendar",
		styleguidePath: "Atoms/Forms/Calendar",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Checkbox",
		path: "atoms/forms/Checkbox",
		styleguidePath: "Atoms/Forms/Checkbox",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "CheckboxToggle",
		path: "atoms/forms/CheckboxToggle",
		styleguidePath: "Atoms/Forms/CheckboxToggle",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Datepicker",
		path: "atoms/forms/Datepicker",
		styleguidePath: "Atoms/Forms/Datepicker",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "FieldDescription",
		path: "atoms/forms/FieldDescription",
		styleguidePath: "Atoms/Forms/FieldDescription",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Input",
		path: "atoms/forms/Input/Input",
		styleguidePath: "Atoms/Forms/Input/Input",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "Prefix",
		path: "atoms/forms/Input/Prefix",
		styleguidePath: "Atoms/Forms/Input/Prefix",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "Suffix",
		path: "atoms/forms/Input/Suffix",
		styleguidePath: "Atoms/Forms/Input/Suffix",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "TextPrompt",
		path: "atoms/forms/Input/TextPrompt",
		styleguidePath: "Atoms/Forms/Input/TextPrompt",
		importPath: "web-ui-components/lib/atoms/forms/input"
	},
	{
		name: "InputClickable",
		path: "atoms/forms/InputClickable",
		styleguidePath: "Atoms/Forms/InputClickable",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "InputRange",
		path: "atoms/forms/InputRange",
		styleguidePath: "Atoms/Forms/InputRange",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "LabelTitle",
		path: "atoms/forms/Label/LabelTitle",
		styleguidePath: "Atoms/Forms/Label/LabelTitle",
		importPath: "web-ui-components/lib/atoms/forms/label"
	},
	{
		name: "Label",
		path: "atoms/forms/Label",
		styleguidePath: "Atoms/Forms/Label",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MediaCheckbox",
		path: "atoms/forms/MediaCheckbox",
		styleguidePath: "Atoms/Forms/MediaCheckbox",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MediaRadio",
		path: "atoms/forms/MediaRadio",
		styleguidePath: "Atoms/Forms/MediaRadio",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "MultiSelect",
		path: "atoms/forms/MultiSelect",
		styleguidePath: "Atoms/Forms/MultiSelect",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Radio",
		path: "atoms/forms/Radio",
		styleguidePath: "Atoms/Forms/Radio",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "RadioCard",
		path: "atoms/forms/RadioCard",
		styleguidePath: "Atoms/Forms/RadioCard",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Select",
		path: "atoms/forms/Select",
		styleguidePath: "Atoms/Forms/Select",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "Textarea",
		path: "atoms/forms/Textarea",
		styleguidePath: "Atoms/Forms/Textarea",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "TextAreaCharacterCount",
		path: "atoms/forms/TextAreaCharacterCount",
		styleguidePath: "Atoms/Forms/TextAreaCharacterCount",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "TimeEstimationIcon",
		path: "atoms/forms/TimeEstimationIcon",
		styleguidePath: "Atoms/Forms/TimeEstimationIcon",
		importPath: "web-ui-components/lib/atoms/forms"
	},
	{
		name: "AnimatedIcon",
		path: "atoms/iconography/AnimatedIcon",
		styleguidePath: "Atoms/Iconography/AnimatedIcon",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "DistinctiveGeneratedSymbol",
		path: "atoms/iconography/DistinctiveGeneratedSymbol",
		styleguidePath: "Atoms/Iconography/DistinctiveGeneratedSymbol",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "Icon",
		path: "atoms/iconography/Icon",
		styleguidePath: "Atoms/Iconography/Icon",
		importPath: "web-ui-components/lib/atoms/iconography"
	},
	{
		name: "Divider",
		path: "atoms/layout/Divider",
		styleguidePath: "Atoms/Layout/Divider",
		importPath: "web-ui-components/lib/atoms/layout"
	},
	{
		name: "UploadPreviewContainer",
		path: "atoms/layout/UploadPreviewContainer",
		styleguidePath: "Atoms/Layout/UploadPreviewContainer",
		importPath: "web-ui-components/lib/atoms/layout"
	},
	{
		name: "AndroidStoreLogo",
		path: "atoms/logo/AndroidStoreLogo",
		styleguidePath: "Atoms/Logo/AndroidStoreLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "AppleStoreLogo",
		path: "atoms/logo/AppleStoreLogo",
		styleguidePath: "Atoms/Logo/AppleStoreLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BankHeader",
		path: "atoms/logo/BankHeader",
		styleguidePath: "Atoms/Logo/BankHeader",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BLogo",
		path: "atoms/logo/BLogo",
		styleguidePath: "Atoms/Logo/BLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "BLogoCircular",
		path: "atoms/logo/BLogoCircular",
		styleguidePath: "Atoms/Logo/BLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "CBLogo",
		path: "atoms/logo/CBLogo",
		styleguidePath: "Atoms/Logo/CBLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "CBLogoCircular",
		path: "atoms/logo/CBLogoCircular",
		styleguidePath: "Atoms/Logo/CBLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "Header",
		path: "atoms/logo/Header",
		styleguidePath: "Atoms/Logo/Header",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "SwitchGuaranteeLogo",
		path: "atoms/logo/SwitchGuaranteeLogo",
		styleguidePath: "Atoms/Logo/SwitchGuaranteeLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "VMSecondaryRedLogo",
		path: "atoms/logo/VMSecondaryRedLogo",
		styleguidePath: "Atoms/Logo/VMSecondaryRedLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "YBLogo",
		path: "atoms/logo/YBLogo",
		styleguidePath: "Atoms/Logo/YBLogo",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "YBLogoCircular",
		path: "atoms/logo/YBLogoCircular",
		styleguidePath: "Atoms/Logo/YBLogoCircular",
		importPath: "web-ui-components/lib/atoms/logo"
	},
	{
		name: "Popover",
		path: "atoms/popovers/Popover",
		styleguidePath: "Atoms/Popovers/Popover",
		importPath: "web-ui-components/lib/atoms/popovers"
	},
	{
		name: "IdentityProcessingSignal",
		path: "atoms/signals/IdentityProcessingSignal",
		styleguidePath: "Atoms/Signals/IdentityProcessingSignal",
		importPath: "web-ui-components/lib/atoms/signals"
	},
	{
		name: "UploadProcessingSignal",
		path: "atoms/signals/UploadProcessingSignal",
		styleguidePath: "Atoms/Signals/UploadProcessingSignal",
		importPath: "web-ui-components/lib/atoms/signals"
	},
	{
		name: "BadgeLabel",
		path: "atoms/text/BadgeLabel",
		styleguidePath: "Atoms/Text/BadgeLabel",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "BulletedList",
		path: "atoms/text/BulletedList",
		styleguidePath: "Atoms/Text/BulletedList",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "Callout",
		path: "atoms/text/Callout",
		styleguidePath: "Atoms/Text/Callout",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "List",
		path: "atoms/text/List",
		styleguidePath: "Atoms/Text/List",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "NumberedList",
		path: "atoms/text/NumberedList",
		styleguidePath: "Atoms/Text/NumberedList",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "StatusBadge",
		path: "atoms/text/StatusBadge",
		styleguidePath: "Atoms/Text/StatusBadge",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TextBody",
		path: "atoms/text/TextBody",
		styleguidePath: "Atoms/Text/TextBody",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TextStyled",
		path: "atoms/text/TextStyled",
		styleguidePath: "Atoms/Text/TextStyled",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TheSmallPrint",
		path: "atoms/text/TheSmallPrint",
		styleguidePath: "Atoms/Text/TheSmallPrint",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "Title",
		path: "atoms/text/Title",
		styleguidePath: "Atoms/Text/Title",
		importPath: "web-ui-components/lib/atoms/text"
	},
	{
		name: "TransitionBlock",
		path: "atoms/transitions/TransitionBlock",
		styleguidePath: "Atoms/Transitions/TransitionBlock",
		importPath: "web-ui-components/lib/atoms/transitions"
	},
	{
		name: "EmailInput",
		path: "communication/email/text-inputs/EmailInput",
		styleguidePath: "Communication/Email/Text-inputs/EmailInput",
		importPath: "web-ui-components/lib/communication/email/text-inputs"
	},
	{
		name: "Mail",
		path: "communication/messaging/Mail",
		styleguidePath: "Communication/Messaging/Mail",
		importPath: "web-ui-components/lib/communication/messaging"
	},
	{
		name: "Webchat",
		path: "communication/support/Webchat",
		styleguidePath: "Communication/Support/Webchat",
		importPath: "web-ui-components/lib/communication/support"
	},
	{
		name: "CheckboxContainer",
		path: "data/capture/checkboxes/CheckboxContainer",
		styleguidePath: "Data/Capture/Checkboxes/CheckboxContainer",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "GenericCheckbox",
		path: "data/capture/checkboxes/GenericCheckbox",
		styleguidePath: "Data/Capture/Checkboxes/GenericCheckbox",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "StandaloneCheckbox",
		path: "data/capture/checkboxes/StandaloneCheckbox",
		styleguidePath: "Data/Capture/Checkboxes/StandaloneCheckbox",
		importPath: "web-ui-components/lib/data/capture/checkboxes"
	},
	{
		name: "AccountNumberInput",
		path: "data/capture/inputs/AccountNumberInput",
		styleguidePath: "Data/Capture/Inputs/AccountNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "DateOfBirthInput",
		path: "data/capture/inputs/DateOfBirthInput",
		styleguidePath: "Data/Capture/Inputs/DateOfBirthInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "FileUploadInput",
		path: "data/capture/inputs/FileUploadInput",
		styleguidePath: "Data/Capture/Inputs/FileUploadInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericAlphaNumericInput",
		path: "data/capture/inputs/GenericAlphaNumericInput",
		styleguidePath: "Data/Capture/Inputs/GenericAlphaNumericInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericIntegerInput",
		path: "data/capture/inputs/GenericIntegerInput",
		styleguidePath: "Data/Capture/Inputs/GenericIntegerInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "GenericTextInput",
		path: "data/capture/inputs/GenericTextInput",
		styleguidePath: "Data/Capture/Inputs/GenericTextInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "LandlineNumberInput",
		path: "data/capture/inputs/LandlineNumberInput",
		styleguidePath: "Data/Capture/Inputs/LandlineNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "MoneyInput",
		path: "data/capture/inputs/MoneyInput",
		styleguidePath: "Data/Capture/Inputs/MoneyInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "MonthAndYearDateInput",
		path: "data/capture/inputs/MonthAndYearDateInput",
		styleguidePath: "Data/Capture/Inputs/MonthAndYearDateInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "PasscodeNumberInput",
		path: "data/capture/inputs/PasscodeNumberInput",
		styleguidePath: "Data/Capture/Inputs/PasscodeNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "SliderInput",
		path: "data/capture/inputs/SliderInput",
		styleguidePath: "Data/Capture/Inputs/SliderInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "SortcodeInput",
		path: "data/capture/inputs/SortcodeInput",
		styleguidePath: "Data/Capture/Inputs/SortcodeInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "UKOnlyMobileNumberInput",
		path: "data/capture/inputs/UKOnlyMobileNumberInput",
		styleguidePath: "Data/Capture/Inputs/UKOnlyMobileNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "UKOnlyPostcodeInput",
		path: "data/capture/inputs/UKOnlyPostcodeInput",
		styleguidePath: "Data/Capture/Inputs/UKOnlyPostcodeInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "WorldwideMobileNumberInput",
		path: "data/capture/inputs/WorldwideMobileNumberInput",
		styleguidePath: "Data/Capture/Inputs/WorldwideMobileNumberInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "YearsAndMonthsCountInput",
		path: "data/capture/inputs/YearsAndMonthsCountInput",
		styleguidePath: "Data/Capture/Inputs/YearsAndMonthsCountInput",
		importPath: "web-ui-components/lib/data/capture/inputs"
	},
	{
		name: "DayOfMonthPicker",
		path: "data/capture/pickers/DayOfMonthPicker",
		styleguidePath: "Data/Capture/Pickers/DayOfMonthPicker",
		importPath: "web-ui-components/lib/data/capture/pickers"
	},
	{
		name: "FileProgressTakeover",
		path: "data/capture/progress/FileProgressTakeover",
		styleguidePath: "Data/Capture/Progress/FileProgressTakeover",
		importPath: "web-ui-components/lib/data/capture/progress"
	},
	{
		name: "GenericRadio",
		path: "data/capture/radios/GenericRadio",
		styleguidePath: "Data/Capture/Radios/GenericRadio",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "IconifiedRadio",
		path: "data/capture/radios/IconifiedRadio",
		styleguidePath: "Data/Capture/Radios/IconifiedRadio",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "RadioContainer",
		path: "data/capture/radios/RadioContainer",
		styleguidePath: "Data/Capture/Radios/RadioContainer",
		importPath: "web-ui-components/lib/data/capture/radios"
	},
	{
		name: "AccountCardSelect",
		path: "data/capture/selects/AccountCardSelect",
		styleguidePath: "Data/Capture/Selects/AccountCardSelect",
		importPath: "web-ui-components/lib/data/capture/selects"
	},
	{
		name: "GenericSelect",
		path: "data/capture/selects/GenericSelect",
		styleguidePath: "Data/Capture/Selects/GenericSelect",
		importPath: "web-ui-components/lib/data/capture/selects"
	},
	{
		name: "GenericTextArea",
		path: "data/capture/text-areas/GenericTextArea",
		styleguidePath: "Data/Capture/Text-areas/GenericTextArea",
		importPath: "web-ui-components/lib/data/capture/text-areas"
	},
	{
		name: "InternationalMoneyValue",
		path: "data/display/values/InternationalMoneyValue",
		styleguidePath: "Data/Display/Values/InternationalMoneyValue",
		importPath: "web-ui-components/lib/data/display/values"
	},
	{
		name: "MoneyValue",
		path: "data/display/values/MoneyValue",
		styleguidePath: "Data/Display/Values/MoneyValue",
		importPath: "web-ui-components/lib/data/display/values"
	},
	{
		name: "GenericPaginator",
		path: "data/filter-and-search/paginators/GenericPaginator",
		styleguidePath: "Data/Filter-and-search/Paginators/GenericPaginator",
		importPath: "web-ui-components/lib/data/filter-and-search/paginators"
	},
	{
		name: "SearchSelectInput",
		path: "data/filter-and-search/text-inputs/SearchSelectInput",
		styleguidePath: "Data/Filter-and-search/Text-inputs/SearchSelectInput",
		importPath: "web-ui-components/lib/data/filter-and-search/text-inputs"
	},
	{
		name: "SearchTextInput",
		path: "data/filter-and-search/text-inputs/SearchTextInput",
		styleguidePath: "Data/Filter-and-search/Text-inputs/SearchTextInput",
		importPath: "web-ui-components/lib/data/filter-and-search/text-inputs"
	},
	{
		name: "CompactDescriptionList",
		path: "data/lists/description-lists/CompactDescriptionList",
		styleguidePath: "Data/Lists/Description-lists/CompactDescriptionList",
		importPath: "web-ui-components/lib/data/lists/description-lists"
	},
	{
		name: "GenericDescriptionList",
		path: "data/lists/description-lists/GenericDescriptionList",
		styleguidePath: "Data/Lists/Description-lists/GenericDescriptionList",
		importPath: "web-ui-components/lib/data/lists/description-lists"
	},
	{
		name: "NoResultsTile",
		path: "data/results/tiles/NoResultsTile",
		styleguidePath: "Data/Results/Tiles/NoResultsTile",
		importPath: "web-ui-components/lib/data/results/tiles"
	},
	{
		name: "DocumentLink",
		path: "documents/navigation/links/DocumentLink",
		styleguidePath: "Documents/Navigation/Links/DocumentLink",
		importPath: "web-ui-components/lib/documents/navigation/links"
	},
	{
		name: "DocumentLinkPlate",
		path: "documents/navigation/plates/DocumentLinkPlate",
		styleguidePath: "Documents/Navigation/Plates/DocumentLinkPlate",
		importPath: "web-ui-components/lib/documents/navigation/plates"
	},
	{
		name: "PrintButton",
		path: "documents/printing/buttons/PrintButton",
		styleguidePath: "Documents/Printing/Buttons/PrintButton",
		importPath: "web-ui-components/lib/documents/printing/buttons"
	},
	{
		name: "DocumentStatusBandCard",
		path: "documents/statuses/cards/DocumentStatusBandCard",
		styleguidePath: "Documents/Statuses/Cards/DocumentStatusBandCard",
		importPath: "web-ui-components/lib/documents/statuses/cards"
	},
	{
		name: "FileInput",
		path: "documents/upload/FileInput",
		styleguidePath: "Documents/Upload/FileInput",
		importPath: "web-ui-components/lib/documents/upload"
	},
	{
		name: "AccountCheckboxCard",
		path: "finance/accounts/cards/AccountCheckboxCard",
		styleguidePath: "Finance/Accounts/Cards/AccountCheckboxCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountLegacyUpdateCard",
		path: "finance/accounts/cards/AccountLegacyUpdateCard",
		styleguidePath: "Finance/Accounts/Cards/AccountLegacyUpdateCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountLinkCard",
		path: "finance/accounts/cards/AccountLinkCard",
		styleguidePath: "Finance/Accounts/Cards/AccountLinkCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountPoolCard",
		path: "finance/accounts/cards/AccountPoolCard",
		styleguidePath: "Finance/Accounts/Cards/AccountPoolCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountSelectCard",
		path: "finance/accounts/cards/AccountSelectCard",
		styleguidePath: "Finance/Accounts/Cards/AccountSelectCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountStaticCard",
		path: "finance/accounts/cards/AccountStaticCard",
		styleguidePath: "Finance/Accounts/Cards/AccountStaticCard",
		importPath: "web-ui-components/lib/finance/accounts/cards"
	},
	{
		name: "AccountAuthorisationPanel",
		path: "finance/accounts/panels/AccountAuthorisationPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountAuthorisationPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountBalancesSelectPanel",
		path: "finance/accounts/panels/AccountBalancesSelectPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountBalancesSelectPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountLegacyPanel",
		path: "finance/accounts/panels/AccountLegacyPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountLegacyPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountPaymentStatusPanel",
		path: "finance/accounts/panels/AccountPaymentStatusPanel",
		styleguidePath: "Finance/Accounts/Panels/AccountPaymentStatusPanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountPoolTablePanel",
		path: "finance/accounts/panels/AccountPoolTablePanel",
		styleguidePath: "Finance/Accounts/Panels/AccountPoolTablePanel",
		importPath: "web-ui-components/lib/finance/accounts/panels"
	},
	{
		name: "AccountRadioCard",
		path: "finance/accounts/radios/AccountRadioCard",
		styleguidePath: "Finance/Accounts/Radios/AccountRadioCard",
		importPath: "web-ui-components/lib/finance/accounts/radios"
	},
	{
		name: "AccountPaymentReviewTable",
		path: "finance/accounts/tables/AccountPaymentReviewTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentReviewTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountPaymentSubmittedTable",
		path: "finance/accounts/tables/AccountPaymentSubmittedTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentSubmittedTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountPaymentTable",
		path: "finance/accounts/tables/AccountPaymentTable",
		styleguidePath: "Finance/Accounts/Tables/AccountPaymentTable",
		importPath: "web-ui-components/lib/finance/accounts/tables"
	},
	{
		name: "AccountSummaryTile",
		path: "finance/accounts/tiles/AccountSummaryTile",
		styleguidePath: "Finance/Accounts/Tiles/AccountSummaryTile",
		importPath: "web-ui-components/lib/finance/accounts/tiles"
	},
	{
		name: "CurrencySelect",
		path: "finance/currency/selects/CurrencySelect",
		styleguidePath: "Finance/Currency/Selects/CurrencySelect",
		importPath: "web-ui-components/lib/finance/currency/selects"
	},
	{
		name: "BlockField",
		path: "global/layout/BlockField",
		styleguidePath: "Global/Layout/BlockField",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "BlockFieldColumn",
		path: "global/layout/BlockFieldColumn",
		styleguidePath: "Global/Layout/BlockFieldColumn",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "CenterImageContainer",
		path: "global/layout/CenterImageContainer",
		styleguidePath: "Global/Layout/CenterImageContainer",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Column",
		path: "global/layout/Column",
		styleguidePath: "Global/Layout/Column",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Container",
		path: "global/layout/Container",
		styleguidePath: "Global/Layout/Container",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "FlexColumn",
		path: "global/layout/FlexColumn",
		styleguidePath: "Global/Layout/FlexColumn",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "FlexRow",
		path: "global/layout/FlexRow",
		styleguidePath: "Global/Layout/FlexRow",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Frame",
		path: "global/layout/Frame",
		styleguidePath: "Global/Layout/Frame",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "InternalSlot",
		path: "global/layout/InternalSlot",
		styleguidePath: "Global/Layout/InternalSlot",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "LeftAndRightAlignment",
		path: "global/layout/LeftAndRightAlignment",
		styleguidePath: "Global/Layout/LeftAndRightAlignment",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "PageLayout",
		path: "global/layout/PageLayout",
		styleguidePath: "Global/Layout/PageLayout",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "HeaderSection",
		path: "global/layout/Pages/HeaderSection",
		styleguidePath: "Global/Layout/Pages/HeaderSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "ServicingSection",
		path: "global/layout/Pages/ServicingSection",
		styleguidePath: "Global/Layout/Pages/ServicingSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "WorkflowSection",
		path: "global/layout/Pages/WorkflowSection",
		styleguidePath: "Global/Layout/Pages/WorkflowSection",
		importPath: "web-ui-components/lib/global/layout/pages"
	},
	{
		name: "ResponsiveLayoutPair",
		path: "global/layout/ResponsiveLayoutPair",
		styleguidePath: "Global/Layout/ResponsiveLayoutPair",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "Row",
		path: "global/layout/Row",
		styleguidePath: "Global/Layout/Row",
		importPath: "web-ui-components/lib/global/layout"
	},
	{
		name: "ContentContainer",
		path: "layout/containers/ContentContainer",
		styleguidePath: "Layout/Containers/ContentContainer",
		importPath: "web-ui-components/lib/layout/containers"
	},
	{
		name: "Main",
		path: "layout/containers/Main",
		styleguidePath: "Layout/Containers/Main",
		importPath: "web-ui-components/lib/layout/containers"
	},
	{
		name: "GenericAccordion",
		path: "layout/content/accordions/GenericAccordion",
		styleguidePath: "Layout/Content/Accordions/GenericAccordion",
		importPath: "web-ui-components/lib/layout/content/accordions"
	},
	{
		name: "StatusBanner",
		path: "layout/content/banners/StatusBanner",
		styleguidePath: "Layout/Content/Banners/StatusBanner",
		importPath: "web-ui-components/lib/layout/content/banners"
	},
	{
		name: "GenericDivider",
		path: "layout/content/breaks/GenericDivider",
		styleguidePath: "Layout/Content/Breaks/GenericDivider",
		importPath: "web-ui-components/lib/layout/content/breaks"
	},
	{
		name: "GenericModal",
		path: "layout/content/modals/GenericModal",
		styleguidePath: "Layout/Content/Modals/GenericModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "InformationModal",
		path: "layout/content/modals/InformationModal",
		styleguidePath: "Layout/Content/Modals/InformationModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "MultiButtonModal",
		path: "layout/content/modals/MultiButtonModal",
		styleguidePath: "Layout/Content/Modals/MultiButtonModal",
		importPath: "web-ui-components/lib/layout/content/modals"
	},
	{
		name: "BrandedPanel",
		path: "layout/content/panels/BrandedPanel",
		styleguidePath: "Layout/Content/Panels/BrandedPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ConditionalPanel",
		path: "layout/content/panels/ConditionalPanel",
		styleguidePath: "Layout/Content/Panels/ConditionalPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ContentRevealPanel",
		path: "layout/content/panels/ContentRevealPanel",
		styleguidePath: "Layout/Content/Panels/ContentRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "GenericPanel",
		path: "layout/content/panels/GenericPanel",
		styleguidePath: "Layout/Content/Panels/GenericPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "InformationRevealPanel",
		path: "layout/content/panels/InformationRevealPanel",
		styleguidePath: "Layout/Content/Panels/InformationRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ShellPanel",
		path: "layout/content/panels/ShellPanel",
		styleguidePath: "Layout/Content/Panels/ShellPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ShellSidebarPanel",
		path: "layout/content/panels/ShellSidebarPanel",
		styleguidePath: "Layout/Content/Panels/ShellSidebarPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "SimplePanel",
		path: "layout/content/panels/SimplePanel",
		styleguidePath: "Layout/Content/Panels/SimplePanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "StatusPanel",
		path: "layout/content/panels/StatusPanel",
		styleguidePath: "Layout/Content/Panels/StatusPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "SubformRevealPanel",
		path: "layout/content/panels/SubformRevealPanel",
		styleguidePath: "Layout/Content/Panels/SubformRevealPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ToggleButtonPanel",
		path: "layout/content/panels/ToggleButtonPanel",
		styleguidePath: "Layout/Content/Panels/ToggleButtonPanel",
		importPath: "web-ui-components/lib/layout/content/panels"
	},
	{
		name: "ProcessingScreenTakeover",
		path: "layout/content/takeovers/ProcessingScreenTakeover",
		styleguidePath: "Layout/Content/Takeovers/ProcessingScreenTakeover",
		importPath: "web-ui-components/lib/layout/content/takeovers"
	},
	{
		name: "AttentionTile",
		path: "layout/content/tiles/AttentionTile",
		styleguidePath: "Layout/Content/Tiles/AttentionTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "GuidanceTile",
		path: "layout/content/tiles/GuidanceTile",
		styleguidePath: "Layout/Content/Tiles/GuidanceTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "OutcomeTile",
		path: "layout/content/tiles/OutcomeTile",
		styleguidePath: "Layout/Content/Tiles/OutcomeTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "RecapTile",
		path: "layout/content/tiles/RecapTile",
		styleguidePath: "Layout/Content/Tiles/RecapTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "StandoutTile",
		path: "layout/content/tiles/StandoutTile",
		styleguidePath: "Layout/Content/Tiles/StandoutTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "ValidationMessageTile",
		path: "layout/content/tiles/ValidationMessageTile",
		styleguidePath: "Layout/Content/Tiles/ValidationMessageTile",
		importPath: "web-ui-components/lib/layout/content/tiles"
	},
	{
		name: "GridListToggle",
		path: "layout/content/views/GridListToggle",
		styleguidePath: "Layout/Content/Views/GridListToggle",
		importPath: "web-ui-components/lib/layout/content/views"
	},
	{
		name: "GridViewToggle",
		path: "layout/content/views/GridViewToggle",
		styleguidePath: "Layout/Content/Views/GridViewToggle",
		importPath: "web-ui-components/lib/layout/content/views"
	},
	{
		name: "GenericFieldWrapper",
		path: "layout/fieldWrappers/GenericFieldWrapper",
		styleguidePath: "Layout/Field-wrappers/GenericFieldWrapper",
		importPath: "web-ui-components/lib/layout/fieldWrappers"
	},
	{
		name: "GroupFieldWrapper",
		path: "layout/fieldWrappers/GroupFieldWrapper",
		styleguidePath: "Layout/Field-wrappers/GroupFieldWrapper",
		importPath: "web-ui-components/lib/layout/fieldWrappers"
	},
	{
		name: "MainFixedFooter",
		path: "layout/footers/MainFixedFooter",
		styleguidePath: "Layout/Footers/MainFixedFooter",
		importPath: "web-ui-components/lib/layout/footers"
	},
	{
		name: "Grid",
		path: "layout/grids/Grid",
		styleguidePath: "Layout/Grids/Grid",
		importPath: "web-ui-components/lib/layout/grids"
	},
	{
		name: "Inline",
		path: "layout/grids/Inline",
		styleguidePath: "Layout/Grids/Inline",
		importPath: "web-ui-components/lib/layout/grids"
	},
	{
		name: "ContainedHeader",
		path: "layout/headers/ContainedHeader",
		styleguidePath: "Layout/Headers/ContainedHeader",
		importPath: "web-ui-components/lib/layout/headers"
	},
	{
		name: "FixedFooter",
		path: "layout/sections/footers/FixedFooter",
		styleguidePath: "Layout/Sections/Footers/FixedFooter",
		importPath: "web-ui-components/lib/layout/sections/footers"
	},
	{
		name: "ApplicationFormShell",
		path: "layout/shells/ApplicationFormShell",
		styleguidePath: "Layout/Shells/ApplicationFormShell",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "DataManagementShell",
		path: "layout/shells/DataManagementShell",
		styleguidePath: "Layout/Shells/DataManagementShell",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "ShellInnerSpacer",
		path: "layout/shells/ShellInnerSpacer",
		styleguidePath: "Layout/Shells/ShellInnerSpacer",
		importPath: "web-ui-components/lib/layout/shells"
	},
	{
		name: "VerticalReviewTable",
		path: "layout/tables/VerticalReviewTable",
		styleguidePath: "Layout/Tables/VerticalReviewTable",
		importPath: "web-ui-components/lib/layout/tables"
	},
	{
		name: "NonUKAddressFieldset",
		path: "location/addresses/fieldsets/NonUKAddressFieldset",
		styleguidePath: "Location/Addresses/Fieldsets/NonUKAddressFieldset",
		importPath: "web-ui-components/lib/location/addresses/fieldsets"
	},
	{
		name: "UKAddressFieldset",
		path: "location/addresses/fieldsets/UKAddressFieldset",
		styleguidePath: "Location/Addresses/Fieldsets/UKAddressFieldset",
		importPath: "web-ui-components/lib/location/addresses/fieldsets"
	},
	{
		name: "UKAddressCaptureModule",
		path: "location/addresses/modules/UKAddressCaptureModule",
		styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule",
		importPath: "web-ui-components/lib/location/addresses/modules"
	},
	{
		name: "UKAddressCaptureModule2",
		path: "location/addresses/modules/UKAddressCaptureModule2",
		styleguidePath: "Location/Addresses/Modules/UKAddressCaptureModule2",
		importPath: "web-ui-components/lib/location/addresses/modules"
	},
	{
		name: "BaseSelect",
		path: "location/places/selects/BaseSelect",
		styleguidePath: "Location/Places/Selects/BaseSelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "CountrySelect",
		path: "location/places/selects/CountrySelect",
		styleguidePath: "Location/Places/Selects/CountrySelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "UKCitySelect",
		path: "location/places/selects/UKCitySelect",
		styleguidePath: "Location/Places/Selects/UKCitySelect",
		importPath: "web-ui-components/lib/location/places/selects"
	},
	{
		name: "AccordionItem",
		path: "molecules/accordions/Accordion/AccordionItem",
		styleguidePath: "Molecules/Accordions/Accordion/AccordionItem",
		importPath: "web-ui-components/lib/molecules/accordions/accordion"
	},
	{
		name: "Accordion",
		path: "molecules/accordions/Accordion",
		styleguidePath: "Molecules/Accordions/Accordion",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "AccordionTable",
		path: "molecules/accordions/AccordionTable",
		styleguidePath: "Molecules/Accordions/AccordionTable",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ContentReveal",
		path: "molecules/accordions/ContentReveal",
		styleguidePath: "Molecules/Accordions/ContentReveal",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ExpansionPanel",
		path: "molecules/accordions/ExpansionPanel",
		styleguidePath: "Molecules/Accordions/ExpansionPanel",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ExpansionTable",
		path: "molecules/accordions/ExpansionTable",
		styleguidePath: "Molecules/Accordions/ExpansionTable",
		importPath: "web-ui-components/lib/molecules/accordions"
	},
	{
		name: "ButtonGroup",
		path: "molecules/buttons/ButtonGroup",
		styleguidePath: "Molecules/Buttons/ButtonGroup",
		importPath: "web-ui-components/lib/molecules/buttons"
	},
	{
		name: "SortingCardGroup",
		path: "molecules/card-groups/SortingCardGroup",
		styleguidePath: "Molecules/Card-groups/SortingCardGroup",
		importPath: "web-ui-components/lib/molecules/card-groups"
	},
	{
		name: "AccountCard",
		path: "molecules/cards/AccountCard",
		styleguidePath: "Molecules/Cards/AccountCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "AccountSummaryLinkCard",
		path: "molecules/cards/AccountSummaryLinkCard",
		styleguidePath: "Molecules/Cards/AccountSummaryLinkCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "DateCard",
		path: "molecules/cards/DateCard",
		styleguidePath: "Molecules/Cards/DateCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "PromoCard",
		path: "molecules/cards/PromoCard",
		styleguidePath: "Molecules/Cards/PromoCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "StackingCard",
		path: "molecules/cards/StackingCard",
		styleguidePath: "Molecules/Cards/StackingCard",
		importPath: "web-ui-components/lib/molecules/cards"
	},
	{
		name: "Autocomplete",
		path: "molecules/forms/Autocomplete",
		styleguidePath: "Molecules/Forms/Autocomplete",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "ConfirmationCheckbox",
		path: "molecules/forms/ConfirmationCheckbox",
		styleguidePath: "Molecules/Forms/ConfirmationCheckbox",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "DaySelector",
		path: "molecules/forms/DaySelector",
		styleguidePath: "Molecules/Forms/DaySelector",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "FieldBody",
		path: "molecules/forms/Field/FieldBody",
		styleguidePath: "Molecules/Forms/Field/FieldBody",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "FieldHeader",
		path: "molecules/forms/Field/FieldHeader",
		styleguidePath: "Molecules/Forms/Field/FieldHeader",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "FormField",
		path: "molecules/forms/Field/FormField",
		styleguidePath: "Molecules/Forms/Field/FormField",
		importPath: "web-ui-components/lib/molecules/forms/field"
	},
	{
		name: "Field",
		path: "molecules/forms/Field",
		styleguidePath: "Molecules/Forms/Field",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "PasswordReveal",
		path: "molecules/forms/PasswordReveal",
		styleguidePath: "Molecules/Forms/PasswordReveal",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "RadioCardGroup",
		path: "molecules/forms/RadioCardGroup",
		styleguidePath: "Molecules/Forms/RadioCardGroup",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "Search",
		path: "molecules/forms/Search",
		styleguidePath: "Molecules/Forms/Search",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SearchForm",
		path: "molecules/forms/SearchForm",
		styleguidePath: "Molecules/Forms/SearchForm",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SegmentedControl",
		path: "molecules/forms/SegmentedControl",
		styleguidePath: "Molecules/Forms/SegmentedControl",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "SegmentedControlItem",
		path: "molecules/forms/SegmentedControl/SegmentedControlItem",
		styleguidePath: "Molecules/Forms/SegmentedControl/SegmentedControlItem",
		importPath: "web-ui-components/lib/molecules/forms/segmentedControl"
	},
	{
		name: "SegmentedSlider",
		path: "molecules/forms/SegmentedSlider",
		styleguidePath: "Molecules/Forms/SegmentedSlider",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "ValidationMessage",
		path: "molecules/forms/ValidationMessage",
		styleguidePath: "Molecules/Forms/ValidationMessage",
		importPath: "web-ui-components/lib/molecules/forms"
	},
	{
		name: "IconTextDynamic",
		path: "molecules/icon-text-dynamic/IconTextDynamic",
		styleguidePath: "Molecules/IconTextDynamic/IconTextDynamic",
		importPath: "web-ui-components/lib/molecules/icon-text-dynamic"
	},
	{
		name: "IconText",
		path: "molecules/icon-text/IconText",
		styleguidePath: "Molecules/IconText/IconText",
		importPath: "web-ui-components/lib/molecules/icon-text"
	},
	{
		name: "BackAnchor",
		path: "molecules/navigation/BackAnchor",
		styleguidePath: "Molecules/Navigation/BackAnchor",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "BackButton",
		path: "molecules/navigation/BackButton",
		styleguidePath: "Molecules/Navigation/BackButton",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "Utility",
		path: "molecules/navigation/Utility",
		styleguidePath: "Molecules/Navigation/Utility",
		importPath: "web-ui-components/lib/molecules/navigation"
	},
	{
		name: "Alert",
		path: "molecules/nbas/Alert",
		styleguidePath: "Molecules/NBAS/Alert",
		importPath: "web-ui-components/lib/molecules/nbas"
	},
	{
		name: "Promo",
		path: "molecules/nbas/Promo",
		styleguidePath: "Molecules/NBAS/Promo",
		importPath: "web-ui-components/lib/molecules/nbas"
	},
	{
		name: "ContrastingFormPanel",
		path: "molecules/panels/ContrastingFormPanel",
		styleguidePath: "Molecules/Panels/ContrastingFormPanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "DocumentAction",
		path: "molecules/panels/DocumentAction",
		styleguidePath: "Molecules/Panels/DocumentAction",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "IconifiedBulletPoint",
		path: "molecules/panels/IconifiedBulletPoint",
		styleguidePath: "Molecules/Panels/IconifiedBulletPoint",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "Panel",
		path: "molecules/panels/Panel",
		styleguidePath: "Molecules/Panels/Panel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "PanelBody",
		path: "molecules/panels/Panel/PanelBody",
		styleguidePath: "Molecules/Panels/Panel/PanelBody",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelFooter",
		path: "molecules/panels/Panel/PanelFooter",
		styleguidePath: "Molecules/Panels/Panel/PanelFooter",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelHeader",
		path: "molecules/panels/Panel/PanelHeader",
		styleguidePath: "Molecules/Panels/Panel/PanelHeader",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "PanelSector",
		path: "molecules/panels/Panel/PanelSector",
		styleguidePath: "Molecules/Panels/Panel/PanelSector",
		importPath: "web-ui-components/lib/molecules/panels/panel"
	},
	{
		name: "SettingLink",
		path: "molecules/panels/SettingLink",
		styleguidePath: "Molecules/Panels/SettingLink",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "SubordinatePanel",
		path: "molecules/panels/SubordinatePanel",
		styleguidePath: "Molecules/Panels/SubordinatePanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "TogglePanel",
		path: "molecules/panels/TogglePanel",
		styleguidePath: "Molecules/Panels/TogglePanel",
		importPath: "web-ui-components/lib/molecules/panels"
	},
	{
		name: "PayeeCard",
		path: "molecules/payee-cards/PayeeCard",
		styleguidePath: "Molecules/PayeeCard/PayeeCard",
		importPath: "web-ui-components/lib/molecules/payee-cards"
	},
	{
		name: "PaymentReview",
		path: "molecules/payments/PaymentReview",
		styleguidePath: "Molecules/Payments/PaymentReview",
		importPath: "web-ui-components/lib/molecules/payments"
	},
	{
		name: "ProgressIndicator",
		path: "molecules/progress/ProgressIndicator",
		styleguidePath: "Molecules/Progress/ProgressIndicator",
		importPath: "web-ui-components/lib/molecules/progress"
	},
	{
		name: "ProgressIndicatorItem",
		path: "molecules/progress/ProgressIndicator/ProgressIndicatorItem",
		styleguidePath: "Molecules/Progress/ProgressIndicator/ProgressIndicatorItem",
		importPath: "web-ui-components/lib/molecules/progress/progressIndicator"
	},
	{
		name: "ComparisonTable",
		path: "molecules/tables/ComparisonTable",
		styleguidePath: "Molecules/Tables/ComparisonTable",
		importPath: "web-ui-components/lib/molecules/tables"
	},
	{
		name: "DataTable",
		path: "molecules/tables/Table/DataTable",
		styleguidePath: "Molecules/Tables/Table/DataTable",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "Table",
		path: "molecules/tables/Table/Table",
		styleguidePath: "Molecules/Tables/Table/Table",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableBody",
		path: "molecules/tables/Table/TableBody",
		styleguidePath: "Molecules/Tables/Table/TableBody",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableBodyData",
		path: "molecules/tables/Table/TableBodyData",
		styleguidePath: "Molecules/Tables/Table/TableBodyData",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableHead",
		path: "molecules/tables/Table/TableHead",
		styleguidePath: "Molecules/Tables/Table/TableHead",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableHeadData",
		path: "molecules/tables/Table/TableHeadData",
		styleguidePath: "Molecules/Tables/Table/TableHeadData",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "TableRow",
		path: "molecules/tables/Table/TableRow",
		styleguidePath: "Molecules/Tables/Table/TableRow",
		importPath: "web-ui-components/lib/molecules/tables/table"
	},
	{
		name: "SectionHeading",
		path: "molecules/text/SectionHeading",
		styleguidePath: "Molecules/Text/SectionHeading",
		importPath: "web-ui-components/lib/molecules/text"
	},
	{
		name: "ConfirmationTile",
		path: "molecules/tile/ConfirmationTile",
		styleguidePath: "Molecules/Tile/ConfirmationTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "ExclamationTile",
		path: "molecules/tile/ExclamationTile",
		styleguidePath: "Molecules/Tile/ExclamationTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "HighlightTile",
		path: "molecules/tile/HighlightTile",
		styleguidePath: "Molecules/Tile/HighlightTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "IconTile",
		path: "molecules/tile/IconTile",
		styleguidePath: "Molecules/Tile/IconTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "NumberedTile",
		path: "molecules/tile/NumberedTile",
		styleguidePath: "Molecules/Tile/NumberedTile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "Tile",
		path: "molecules/tile/Tile",
		styleguidePath: "Molecules/Tile/Tile",
		importPath: "web-ui-components/lib/molecules/tile"
	},
	{
		name: "TileSector",
		path: "molecules/tile/Tile/TileSector",
		styleguidePath: "Molecules/Tile/Tile/TileSector",
		importPath: "web-ui-components/lib/molecules/tile/tile"
	},
	{
		name: "TileSegment",
		path: "molecules/tile/Tile/TileSegment",
		styleguidePath: "Molecules/Tile/Tile/TileSegment",
		importPath: "web-ui-components/lib/molecules/tile/tile"
	},
	{
		name: "ToggleOption",
		path: "molecules/toggle/ToggleOption",
		styleguidePath: "Molecules/Toggle/ToggleOption",
		importPath: "web-ui-components/lib/molecules/toggle"
	},
	{
		name: "PromoAnchor",
		path: "navigation/anchors/PromoAnchor",
		styleguidePath: "Navigation/Anchors/PromoAnchor",
		importPath: "web-ui-components/lib/navigation/anchors"
	},
	{
		name: "NavigationButton",
		path: "navigation/buttons/NavigationButton",
		styleguidePath: "Navigation/Buttons/NavigationButton",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "NavigationButtonGroup",
		path: "navigation/buttons/NavigationButtonGroup",
		styleguidePath: "Navigation/Buttons/NavigationButtonGroup",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "PromoButton",
		path: "navigation/buttons/PromoButton",
		styleguidePath: "Navigation/Buttons/PromoButton",
		importPath: "web-ui-components/lib/navigation/buttons"
	},
	{
		name: "ProgressStepper",
		path: "navigation/indicators/ProgressStepper",
		styleguidePath: "Navigation/Indicators/ProgressStepper",
		importPath: "web-ui-components/lib/navigation/indicators"
	},
	{
		name: "VerticalMenu",
		path: "navigation/menus/VerticalMenu",
		styleguidePath: "Navigation/Menus/VerticalMenu",
		importPath: "web-ui-components/lib/navigation/menus"
	},
	{
		name: "MainNavLink",
		path: "navigation/nav-links/MainNavLink",
		styleguidePath: "Navigation/Nav-links/MainNavLink",
		importPath: "web-ui-components/lib/navigation/nav-links"
	},
	{
		name: "Paginator",
		path: "navigation/pagination/Paginator",
		styleguidePath: "Navigation/Pagination/Paginator",
		importPath: "web-ui-components/lib/navigation/pagination"
	},
	{
		name: "PaginatorNextButton",
		path: "navigation/pagination/Paginator/PaginatorNextButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorNextButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "PaginatorPageButton",
		path: "navigation/pagination/Paginator/PaginatorPageButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorPageButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "PaginatorPreviousButton",
		path: "navigation/pagination/Paginator/PaginatorPreviousButton",
		styleguidePath: "Navigation/Pagination/Paginator/PaginatorPreviousButton",
		importPath: "web-ui-components/lib/navigation/pagination/paginator"
	},
	{
		name: "MainSiteNav",
		path: "navigation/site-navs/MainSiteNav",
		styleguidePath: "Navigation/Site-navs/MainSiteNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "MobileMainSiteNav",
		path: "navigation/site-navs/MobileMainSiteNav",
		styleguidePath: "Navigation/Site-navs/MobileMainSiteNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "UtilityNav",
		path: "navigation/site-navs/UtilityNav",
		styleguidePath: "Navigation/Site-navs/UtilityNav",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "UtilityNavButton",
		path: "navigation/site-navs/UtilityNavButton",
		styleguidePath: "Navigation/Site-navs/UtilityNavButton",
		importPath: "web-ui-components/lib/navigation/site-navs"
	},
	{
		name: "TabCard",
		path: "navigation/tab-cards/TabCard",
		styleguidePath: "Navigation/Tab-cards/TabCard",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabCardBlock",
		path: "navigation/tab-cards/TabCardBlock",
		styleguidePath: "Navigation/Tab-cards/TabCardBlock",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabCardSmall",
		path: "navigation/tab-cards/TabCardSmall",
		styleguidePath: "Navigation/Tab-cards/TabCardSmall",
		importPath: "web-ui-components/lib/navigation/tab-cards"
	},
	{
		name: "TabGroup",
		path: "navigation/tab-group/TabGroup",
		styleguidePath: "Navigation/Tab-group/TabGroup",
		importPath: "web-ui-components/lib/navigation/tab-group"
	},
	{
		name: "TransferTakeover",
		path: "navigation/takeovers/TransferTakeover",
		styleguidePath: "Navigation/Takeovers/TransferTakeover",
		importPath: "web-ui-components/lib/navigation/takeovers"
	},
	{
		name: "Card",
		path: "organisms/cards/Card",
		styleguidePath: "Organisms/Cards/Card",
		importPath: "web-ui-components/lib/organisms/cards"
	},
	{
		name: "DistinctiveLinkCard",
		path: "organisms/cards/DistinctiveLinkCard",
		styleguidePath: "Organisms/Cards/DistinctiveLinkCard",
		importPath: "web-ui-components/lib/organisms/cards"
	},
	{
		name: "FilterAction",
		path: "organisms/filters/Filter/FilterActionGroup/FilterAction",
		styleguidePath: "Organisms/Filters/Filter/FilterActionGroup/FilterAction",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterActionGroup"
	},
	{
		name: "FilterActionGroup",
		path: "organisms/filters/Filter/FilterActionGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterActionGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSector",
		path: "organisms/filters/Filter/FilterSector",
		styleguidePath: "Organisms/Filters/Filter/FilterSector",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSegment",
		path: "organisms/filters/Filter/FilterSegmentGroup/FilterSegment",
		styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup/FilterSegment",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterSegmentGroup"
	},
	{
		name: "FilterSegmentGroup",
		path: "organisms/filters/Filter/FilterSegmentGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterSegmentGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "FilterSubSegment",
		path: "organisms/filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
		styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup/FilterSubSegment",
		importPath: "web-ui-components/lib/organisms/filters/filter/filterSubSegmentGroup"
	},
	{
		name: "FilterSubSegmentGroup",
		path: "organisms/filters/Filter/FilterSubSegmentGroup",
		styleguidePath: "Organisms/Filters/Filter/FilterSubSegmentGroup",
		importPath: "web-ui-components/lib/organisms/filters/filter"
	},
	{
		name: "Filter",
		path: "organisms/filters/Filter",
		styleguidePath: "Organisms/Filters/Filter",
		importPath: "web-ui-components/lib/organisms/filters"
	},
	{
		name: "GlobalHeader",
		path: "organisms/global/GlobalHeader",
		styleguidePath: "Organisms/Global/GlobalHeader",
		importPath: "web-ui-components/lib/organisms/global"
	},
	{
		name: "HeroHeader",
		path: "organisms/global/HeroHeader",
		styleguidePath: "Organisms/Global/HeroHeader",
		importPath: "web-ui-components/lib/organisms/global"
	},
	{
		name: "CentredModal",
		path: "organisms/modals/CentredModal",
		styleguidePath: "Organisms/Modals/CentredModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "ConfirmationModal",
		path: "organisms/modals/ConfirmationModal",
		styleguidePath: "Organisms/Modals/ConfirmationModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "Loader",
		path: "organisms/modals/Loader",
		styleguidePath: "Organisms/Modals/Loader",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "ModalBody",
		path: "organisms/modals/Modal/ModalBody",
		styleguidePath: "Organisms/Modals/Modal/ModalBody",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "ModalContainer",
		path: "organisms/modals/Modal/ModalContainer",
		styleguidePath: "Organisms/Modals/Modal/ModalContainer",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "ModalHeader",
		path: "organisms/modals/Modal/ModalHeader",
		styleguidePath: "Organisms/Modals/Modal/ModalHeader",
		importPath: "web-ui-components/lib/organisms/modals/modal"
	},
	{
		name: "Modal",
		path: "organisms/modals/Modal",
		styleguidePath: "Organisms/Modals/Modal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "UnfinishedWorkModal",
		path: "organisms/modals/UnfinishedWorkModal",
		styleguidePath: "Organisms/Modals/UnfinishedWorkModal",
		importPath: "web-ui-components/lib/organisms/modals"
	},
	{
		name: "DisableTakeover",
		path: "organisms/takeovers/DisableTakeover",
		styleguidePath: "Organisms/Takeovers/DisableTakeover",
		importPath: "web-ui-components/lib/organisms/takeovers"
	},
	{
		name: "LoadingLocalTakeover",
		path: "organisms/takeovers/LoadingLocalTakeover",
		styleguidePath: "Organisms/Takeovers/LoadingLocalTakeover",
		importPath: "web-ui-components/lib/organisms/takeovers"
	},
	{
		name: "Timeline",
		path: "organisms/timelines/Timeline",
		styleguidePath: "Organisms/Timeline/Timeline",
		importPath: "web-ui-components/lib/organisms/timelines"
	},
	{
		name: "ProductSelector",
		path: "products/selection/ProductSelector",
		styleguidePath: "Products/Selection/ProductSelector",
		importPath: "web-ui-components/lib/products/selection"
	},
	{
		name: "EmailCreationInput",
		path: "security/authentication/inputs/EmailCreationInput",
		styleguidePath: "Security/Authentication/Inputs/EmailCreationInput",
		importPath: "web-ui-components/lib/security/authentication/inputs"
	},
	{
		name: "PasswordCreationInput",
		path: "security/authentication/inputs/PasswordCreationInput",
		styleguidePath: "Security/Authentication/Inputs/PasswordCreationInput",
		importPath: "web-ui-components/lib/security/authentication/inputs"
	},
	{
		name: "CallButton",
		path: "telephony/Buttons/CallButton",
		styleguidePath: "Telephony/Buttons/CallButton",
		importPath: "web-ui-components/lib/telephony/buttons"
	},
	{
		name: "CallStatus",
		path: "telephony/Statuses/CallStatus",
		styleguidePath: "Telephony/Statuses/CallStatus",
		importPath: "web-ui-components/lib/telephony/statuses"
	},
	{
		name: "LogoDisplay",
		path: "transactions/logo/LogoDisplay",
		styleguidePath: "Transactions/Logo/LogoDisplay",
		importPath: "web-ui-components/lib/transactions/logo"
	},
	{
		name: "Footer",
		path: "typography/ancillary/Footer",
		styleguidePath: "Typography/Ancillary/Footer",
		importPath: "web-ui-components/lib/typography/ancillary"
	},
	{
		name: "LargeBody",
		path: "typography/body/LargeBody",
		styleguidePath: "Typography/Body/LargeBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SecondaryBody",
		path: "typography/body/SecondaryBody",
		styleguidePath: "Typography/Body/SecondaryBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SignificantBody",
		path: "typography/body/SignificantBody",
		styleguidePath: "Typography/Body/SignificantBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SmallestBody",
		path: "typography/body/SmallestBody",
		styleguidePath: "Typography/Body/SmallestBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "StandardBody",
		path: "typography/body/StandardBody",
		styleguidePath: "Typography/Body/StandardBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "SubBody",
		path: "typography/body/SubBody",
		styleguidePath: "Typography/Body/SubBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "VisuallyHiddenBody",
		path: "typography/body/VisuallyHiddenBody",
		styleguidePath: "Typography/Body/VisuallyHiddenBody",
		importPath: "web-ui-components/lib/typography/body"
	},
	{
		name: "PageHeading",
		path: "typography/headings/PageHeading",
		styleguidePath: "Typography/Headings/PageHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SectionHeading",
		path: "typography/headings/SectionHeading",
		styleguidePath: "Typography/Headings/SectionHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SubHeading",
		path: "typography/headings/SubHeading",
		styleguidePath: "Typography/Headings/SubHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "SubsectionHeading",
		path: "typography/headings/SubsectionHeading",
		styleguidePath: "Typography/Headings/SubsectionHeading",
		importPath: "web-ui-components/lib/typography/headings"
	},
	{
		name: "LargeHero",
		path: "typography/heros/LargeHero",
		styleguidePath: "Typography/Heros/LargeHero",
		importPath: "web-ui-components/lib/typography/heros"
	},
	{
		name: "StandardHero",
		path: "typography/heros/StandardHero",
		styleguidePath: "Typography/Heros/StandardHero",
		importPath: "web-ui-components/lib/typography/heros"
	},
	{
		name: "IndicativeHighlight",
		path: "typography/highlights/IndicativeHighlight",
		styleguidePath: "Typography/Highlights/IndicativeHighlight",
		importPath: "web-ui-components/lib/typography/highlights"
	},
	{
		name: "StateIndicator",
		path: "typography/indicators/StateIndicator",
		styleguidePath: "Typography/Indicators/StateIndicator",
		importPath: "web-ui-components/lib/typography/indicators"
	},
	{
		name: "StepIndicator",
		path: "typography/indicators/StepIndicator",
		styleguidePath: "Typography/Indicators/StepIndicator",
		importPath: "web-ui-components/lib/typography/indicators"
	},
	{
		name: "FieldLabel",
		path: "typography/labels/FieldLabel",
		styleguidePath: "Typography/Labels/FieldLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "ProminentLabel",
		path: "typography/labels/ProminentLabel",
		styleguidePath: "Typography/Labels/ProminentLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "StandardLabel",
		path: "typography/labels/StandardLabel",
		styleguidePath: "Typography/Labels/StandardLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "SubLabel",
		path: "typography/labels/SubLabel",
		styleguidePath: "Typography/Labels/SubLabel",
		importPath: "web-ui-components/lib/typography/labels"
	},
	{
		name: "BulletList",
		path: "typography/lists/BulletList",
		styleguidePath: "Typography/Lists/BulletList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "NegativeList",
		path: "typography/lists/NegativeList",
		styleguidePath: "Typography/Lists/NegativeList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "NumberList",
		path: "typography/lists/NumberList",
		styleguidePath: "Typography/Lists/NumberList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "PositiveList",
		path: "typography/lists/PositiveList",
		styleguidePath: "Typography/Lists/PositiveList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "TickList",
		path: "typography/lists/TickList",
		styleguidePath: "Typography/Lists/TickList",
		importPath: "web-ui-components/lib/typography/lists"
	},
	{
		name: "Identifier",
		path: "typography/modifiers/Identifier",
		styleguidePath: "Typography/Modifiers/Identifier",
		importPath: "web-ui-components/lib/typography/modifiers"
	},
	{
		name: "AbbreviatedTag",
		path: "typography/tags/AbbreviatedTag",
		styleguidePath: "Typography/Tags/AbbreviatedTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "StatusTag",
		path: "typography/tags/StatusTag",
		styleguidePath: "Typography/Tags/StatusTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "ValueTag",
		path: "typography/tags/ValueTag",
		styleguidePath: "Typography/Tags/ValueTag",
		importPath: "web-ui-components/lib/typography/tags"
	},
	{
		name: "MostProminentValue",
		path: "typography/values/MostProminentValue",
		styleguidePath: "Typography/Values/MostProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "ProminentValue",
		path: "typography/values/ProminentValue",
		styleguidePath: "Typography/Values/ProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "StandardValue",
		path: "typography/values/StandardValue",
		styleguidePath: "Typography/Values/StandardValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "VeryProminentValue",
		path: "typography/values/VeryProminentValue",
		styleguidePath: "Typography/Values/VeryProminentValue",
		importPath: "web-ui-components/lib/typography/values"
	},
	{
		name: "UserStatusBandCard",
		path: "users/business-users/cards/UserStatusBandCard",
		styleguidePath: "Users/Business-users/Cards/UserStatusBandCard",
		importPath: "web-ui-components/lib/users/business-users/cards"
	}
];

var deprecated = [{
	name: "InputRadio",
	path: "src/actions/radios/InputRadio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "InputRadioGroup",
	path: "src/actions/radios/InputRadioGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.4.0",
	deprecationDate: "February 17 2020"
}, {
	name: "TallRadioCard",
	path: "src/actions/radios/TallRadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "27.13.0",
	deprecationDate: "September 9 2021"
}, {
	name: "WideRadioCard",
	path: "src/actions/radios/WideRadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "27.13.0",
	deprecationDate: "September 9 2021"
}, {
	name: "Anchor",
	path: "src/atoms/buttons/Anchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Button",
	path: "src/atoms/buttons/Button/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "ActionButton",
			path: "Actions/Buttons"
		}, {
			name: "NavigationButton",
			path: "Navigation/Buttons"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "Checkbox",
	path: "src/atoms/forms/Checkbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Datepicker",
	path: "src/atoms/forms/Datepicker/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Calendar",
			path: "Atoms/Forms"
		}
	}],
	deprecationVersion: "7.3.0",
	deprecationDate: "August 30 2018"
}, {
	name: "LabelTitle",
	path: "src/atoms/forms/Label/LabelTitle/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Label",
	path: "src/atoms/forms/Label/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "Radio",
	path: "src/atoms/forms/Radio/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "RadioCard",
	path: "src/atoms/forms/RadioCard/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Select",
	path: "src/atoms/forms/Select/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericSelect",
			path: "Data/Capture/Selects"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "Textarea",
	path: "src/atoms/forms/Textarea/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "19.0.0",
	deprecationDate: "May 03 2019"
}, {
	name: "TextAreaCharacterCount",
	path: "src/atoms/forms/TextAreaCharacterCount/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericTextArea",
			path: "Data/Capture/TextAreas"
		}
	}],
	deprecationVersion: "20.0.0",
	deprecationDate: "May 15 2019"
}, {
	name: "Icon",
	path: "src/atoms/iconography/Icon/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		replacements: {
			name: "ChevronLeftSmall",
			replacement: "ChevronLeftSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineLarge",
			replacement: "CrossOutlineLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "crossOutlineSmall",
			replacement: "CrossOutlineSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidLarge",
			replacement: "CrossSolidLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CrossRoundedSolidSmall",
			replacement: "CrossSolidSmall",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidLarge",
			replacement: "CycleLarge",
			path: "Atoms/Iconography"
		}
	}, {
		replacements: {
			name: "CycleSolidSmall",
			replacement: "CycleSmall",
			path: "Atoms/Iconography"
		}
	}]
}, {
	name: "Divider",
	path: "src/atoms/layout/Divider/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericDivider",
			path: "Layout/Content/Breaks"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BankHeader",
	path: "src/atoms/logo/BankHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Header",
	path: "src/atoms/logo/Header/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "BulletedList",
	path: "src/atoms/text/BulletedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "BulletList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "Callout",
	path: "src/atoms/text/Callout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NumberedList",
	path: "src/atoms/text/NumberedList/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "NumberList",
			path: "Typography/Lists"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "TextBody",
	path: "src/atoms/text/TextBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandardBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TextStyled",
	path: "src/atoms/text/TextStyled/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "22.3.0",
	deprecationDate: "August 05 2019"
}, {
	name: "TheSmallPrint",
	path: "src/atoms/text/TheSmallPrint/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SmallestBody",
			path: "Typography/Body"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Title",
	path: "src/atoms/text/Title/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Headings",
			path: "Typography"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "GenericTextInput",
	path: "src/data/capture/inputs/GenericTextInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAlphaNumericInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "25.1.0",
	deprecationDate: "March 23 2020"
}, {
	name: "DocumentLink",
	path: "src/documents/navigation/links/DocumentLink/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "DocumentLinkPlate",
	path: "src/documents/navigation/plates/DocumentLinkPlate/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "PrintButton",
	path: "src/documents/printing/buttons/PrintButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ActionButton",
			path: "Actions/Buttons/ActionButton"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FileInput",
	path: "src/documents/upload/FileInput/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "FileUploadInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "27.6.0",
	deprecationDate: "November 20 2020"
}, {
	name: "AccountLegacyPanel",
	path: "src/finance/accounts/panels/AccountLegacyPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "AccountBalancesSelectPanel",
			path: "Finance/Accounts/Panels"
		}
	}],
	deprecationVersion: "22.1.0",
	deprecationDate: "July 17 2019"
}, {
	name: "CenterImageContainer",
	path: "src/global/layout/CenterImageContainer/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids",
			variant: "Centered"
		}
	}],
	deprecationVersion: "27.9.0",
	deprecationDate: "March 24 2021"
}, {
	name: "Column",
	path: "src/global/layout/Column/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Container",
	path: "src/global/layout/Container/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentContainer",
			path: "Layout/Sections"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "FlexColumn",
	path: "src/global/layout/FlexColumn/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "FlexRow",
	path: "src/global/layout/FlexRow/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "Frame",
	path: "src/global/layout/Frame/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "LeftAndRightAlignment",
	path: "src/global/layout/LeftAndRightAlignment/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "PageLayout",
	path: "src/global/layout/PageLayout/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "HeaderSection",
	path: "src/global/layout/Pages/HeaderSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ServicingSection",
	path: "src/global/layout/Pages/ServicingSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "DataManagementShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "WorkflowSection",
	path: "src/global/layout/Pages/WorkflowSection/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ResponsiveLayoutPair",
	path: "src/global/layout/ResponsiveLayoutPair/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.2.2",
	deprecationDate: "July 31 2020"
}, {
	name: "Row",
	path: "src/global/layout/Row/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Inline",
			path: "Layout/Grids"
		}
	}],
	deprecationVersion: "27.5.0",
	deprecationDate: "October 30 2020"
}, {
	name: "ContentContainer",
	path: "src/layout/containers/ContentContainer/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Main",
	path: "src/layout/containers/Main/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ApplicationFormShell",
			path: "Layout/Shells/ApplicationFormShell"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ContentRevealPanel",
	path: "src/layout/content/panels/ContentRevealPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.7.0",
	deprecationDate: "December 16 2020"
}, {
	name: "ShellSidebarPanel",
	path: "src/layout/content/panels/ShellSidebarPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ShellPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.9.0",
	deprecationDate: "March 24 2021"
}, {
	name: "GuidanceTile",
	path: "src/layout/content/tiles/GuidanceTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "RecapTile",
	path: "src/layout/content/tiles/RecapTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "GridViewToggle",
	path: "src/layout/content/views/GridViewToggle/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GridListToggle",
			path: "Layout/Content/Views"
		}
	}],
	deprecationVersion: "28.3.0",
	deprecationDate: "January 21 2022"
}, {
	name: "FixedFooter",
	path: "src/layout/sections/footers/FixedFooter/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "MainFixedFooter",
			path: "Layout/Footers"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "AccordionItem",
	path: "src/molecules/accordions/Accordion/AccordionItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "Accordion",
	path: "src/molecules/accordions/Accordion/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "AccordionTable",
	path: "src/molecules/accordions/AccordionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "ContentReveal",
	path: "src/molecules/accordions/ContentReveal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "24.1.0",
	deprecationDate: "March 05 2020"
}, {
	name: "ExpansionPanel",
	path: "src/molecules/accordions/ExpansionPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "SubformRevealPanel",
			path: "Layout/Content/Panels"
		}, {
			name: "GenericAccordion",
			path: "Layout/Content/Accordions/GenericAccordion"
		}, {
			name: "InformationRevealPanel",
			path: "Layout/Content/Panels"
		}]
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ExpansionTable",
	path: "src/molecules/accordions/ExpansionTable/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContentRevealPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "27.3.0",
	deprecationDate: "September 01 2020"
}, {
	name: "ButtonGroup",
	path: "src/molecules/buttons/ButtonGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: [{
			name: "NavigationButtonGroup",
			path: "Navigation/Buttons"
		}, {
			name: "Inline",
			path: "Layout/Grids"
		}]
	}],
	deprecationVersion: "27.4.1",
	deprecationDate: "September 10 2020"
}, {
	name: "ConfirmationCheckbox",
	path: "src/molecules/forms/ConfirmationCheckbox/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandaloneCheckbox",
			path: "Data/Capture/Checkboxes"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "DaySelector",
	path: "src/molecules/forms/DaySelector/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "FieldBody",
	path: "src/molecules/forms/Field/FieldBody/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "FieldHeader",
	path: "src/molecules/forms/Field/FieldHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "Field",
	path: "src/molecules/forms/Field/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericFieldWrapper",
			path: "Layout/Field-wrappers"
		}
	}],
	deprecationVersion: "27.4.0",
	deprecationDate: "September 07 2020"
}, {
	name: "RadioCardGroup",
	path: "src/molecules/forms/RadioCardGroup/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericRadio",
			path: "Data/Capture/Radios"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "SegmentedSlider",
	path: "src/molecules/forms/SegmentedSlider/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SliderInput",
			path: "Data/Capture/Inputs"
		}
	}],
	deprecationVersion: "28.4.0",
	deprecationDate: "June 21 2022"
}, {
	name: "ValidationMessage",
	path: "src/molecules/forms/ValidationMessage/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ValidationMessageTile",
			path: "Layout/Tiles"
		}
	}],
	deprecationVersion: "22.22.0",
	deprecationDate: "January 20 2020"
}, {
	name: "IconText",
	path: "src/molecules/icon-text/IconText/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "IconTextDynamic",
			path: "Molecules/IconTextDynamic"
		}
	}],
	deprecationVersion: "6.4.0",
	deprecationDate: "August 03 2018"
}, {
	name: "BackAnchor",
	path: "src/molecules/navigation/BackAnchor/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "WebsiteLink",
			path: "Actions/Links"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "BackButton",
	path: "src/molecules/navigation/BackButton/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNavButton",
			path: "Navigation/Site-navs"
		}
	}],
	deprecationVersion: "25.5.0",
	deprecationDate: "May 13 2020"
}, {
	name: "Utility",
	path: "src/molecules/navigation/Utility/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "UtilityNav",
			path: "Navigation/Site-Navs/UtilityNav"
		}
	}],
	deprecationVersion: "22.12.0",
	deprecationDate: "September 27 2019"
}, {
	name: "ContrastingFormPanel",
	path: "src/molecules/panels/ContrastingFormPanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericPanel",
			path: "Layout/Content/Panels",
			variant: "Interaction"
		}
	}],
	deprecationVersion: "33.3.0",
	deprecationDate: "April 03 2024"
}, {
	name: "SubordinatePanel",
	path: "src/molecules/panels/SubordinatePanel/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConditionalPanel",
			path: "Layout/Content/Panels"
		}
	}],
	deprecationVersion: "23.1.0",
	deprecationDate: "January 31 2020"
}, {
	name: "ProgressIndicator",
	path: "src/molecules/progress/ProgressIndicator/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "ProgressIndicatorItem",
	path: "src/molecules/progress/ProgressIndicator/ProgressIndicatorItem/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ProgressStepper",
			path: "Navigation/Indicators"
		}
	}],
	deprecationVersion: "26.0.0",
	deprecationDate: "May 22 2020"
}, {
	name: "SectionHeading",
	path: "src/molecules/text/SectionHeading/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "SectionHeading",
			path: "Typography/Headings"
		}
	}],
	deprecationVersion: "23.2.0",
	deprecationDate: "February 06 2020"
}, {
	name: "ConfirmationTile",
	path: "src/molecules/tile/ConfirmationTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "HighlightTile",
	path: "src/molecules/tile/HighlightTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "StandoutTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "IconTile",
	path: "src/molecules/tile/IconTile/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "OutcomeTile",
			path: "Layout/Content/Tiles"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "NavigationButton",
	path: "src/navigation/buttons/NavigationButton/package.json",
	"component-life-cycle": "active",
	deprecations: [{
		variants: ["Confirm", "Continue", "Next", "Submit"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Primary"
		}
	}, {
		variants: ["Back"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Secondary"
		}
	}, {
		variants: ["Cancel"],
		replacements: {
			name: "NavigationButton",
			path: "Navigation/Buttons",
			variant: "Tertiary"
		}
	}],
	deprecationVersion: "NO RELEASE VERSION FOUND",
	deprecationDate: "NO RELEASE DATE FOUND"
}, {
	name: "GlobalHeader",
	path: "src/organisms/global/GlobalHeader/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ContainedHeader",
			path: "Layout/Headers"
		}
	}],
	deprecationVersion: "25.4.0",
	deprecationDate: "May 01 2020"
}, {
	name: "CentredModal",
	path: "src/organisms/modals/CentredModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "ConfirmationModal",
	path: "src/organisms/modals/ConfirmationModal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "GenericModal",
			path: "Layout/Content/Modals"
		}
	}],
	deprecationVersion: "27.8.0",
	deprecationDate: "January 29 2021"
}, {
	name: "Modal",
	path: "src/organisms/modals/Modal/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "ConfirmationModal",
			path: "Organisms/Modals"
		}
	}],
	deprecationVersion: "22.0.0",
	deprecationDate: "July 04 2019"
}, {
	name: "LargeHero",
	path: "src/typography/heros/LargeHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}, {
	name: "StandardHero",
	path: "src/typography/heros/StandardHero/package.json",
	"component-life-cycle": "deprecated",
	deprecations: [{
		replacements: {
			name: "Typography",
			path: "Typography"
		}
	}],
	deprecationVersion: "24.0.0",
	deprecationDate: "February 27 2020"
}];

/* eslint-disable no-console */

var deprecatedDictComponents = {};
var deprecatedDictProps = {};
var timeoutDelay = 100;

var CONSOLE_DEPRECATION_MESSAGE_START = 'Deprecation: web-ui-components';

var DeprecationWarnings = {
	logComponent: function logComponent(componentName) {
		var deprecatedComponentObj = componentPaths.find(function (_ref) {
			var name = _ref.name;
			return name === componentName;
		});
		var oldPath = deprecatedComponentObj.styleguidePath;
		deprecatedComponentObj = deprecated.find(function (_ref2) {
			var name = _ref2.name;
			return name.includes(componentName);
		});

		var depreactionReplacements = deprecatedComponentObj.deprecations[0].replacements;
		var hasMultipleReplacements = Array.isArray(depreactionReplacements);
		var newPath = hasMultipleReplacements ? depreactionReplacements.map(function (replacement) {
			return replacement.path + '/' + replacement.name;
		}) : depreactionReplacements.path + '/' + depreactionReplacements.name;

		deprecatedDictComponents[componentName] = { oldPath: oldPath, newPath: newPath };
	},
	logIcon: function logIcon(componentName, deprecatedIcon) {
		var deprecatedComponentObj = componentPaths.find(function (_ref3) {
			var name = _ref3.name;
			return name.includes(componentName);
		});
		var path = deprecatedComponentObj.styleguidePath;
		var oldPath = path + ': ' + deprecatedIcon;
		var newPath = path + ': ' + deprecatedIcon;
		var iconName = componentName + ': ' + deprecatedIcon;

		deprecatedDictComponents[iconName] = { oldPath: oldPath, newPath: newPath };
	},
	logProp: function logProp(packageJson, description) {
		var _packageJson$main$spl = packageJson.main.split('.'),
		    _packageJson$main$spl2 = slicedToArray(_packageJson$main$spl, 1),
		    componentName = _packageJson$main$spl2[0];

		var deprecatedComponentObj = componentPaths.find(function (_ref4) {
			var name = _ref4.name;
			return name.includes(componentName);
		});
		var path = deprecatedComponentObj.styleguidePath;
		deprecatedDictProps[componentName] = { path: path, description: description };
	},
	report: function report() {
		setTimeout(function () {
			var numberOfDeprecations = Object.keys(deprecatedDictComponents).length + Object.keys(deprecatedDictProps).length;
			if (numberOfDeprecations > 0) {
				console.groupCollapsed('Web UI Components Deprecation Warnings. Total: ' + numberOfDeprecations);

				console.groupCollapsed('Components. Total: ' + Object.keys(deprecatedDictComponents).length);
				Object.entries(deprecatedDictComponents).forEach(function (_ref5) {
					var _ref6 = slicedToArray(_ref5, 2),
					    componentName = _ref6[0],
					    info = _ref6[1];

					var oldPath = info.oldPath,
					    newPath = info.newPath;

					console.groupCollapsed(componentName);
					console.warn('Deprecated:', oldPath);

					var hasMultipleReplacements = Array.isArray(newPath);
					if (hasMultipleReplacements) {
						newPath.map(function (replacement, index) {
							return console.warn('Replacement ' + (index + 1) + ':', replacement);
						});
					} else {
						console.warn('Replacement:', newPath);
					}
					console.groupEnd();
				});
				console.groupEnd();

				console.groupCollapsed('Props. Total: ' + Object.keys(deprecatedDictProps).length);
				Object.entries(deprecatedDictProps).forEach(function (_ref7) {
					var _ref8 = slicedToArray(_ref7, 2),
					    componentName = _ref8[0],
					    info = _ref8[1];

					var path = info.path,
					    description = info.description;

					console.groupCollapsed(componentName);
					console.warn('Deprecated:', path);
					console.warn('Reason:', description);
					console.groupEnd();
				});
				console.groupEnd();

				console.groupEnd();
				deprecatedDictComponents = {};
				deprecatedDictProps = {};
			}
		}, timeoutDelay);
	},
	warn: function warn(message) {
		return console.warn(CONSOLE_DEPRECATION_MESSAGE_START + ' -> ' + message);
	}
};

Object.freeze(DeprecationWarnings);

var main = "NavigationButton.js";
var variants = ["Back", "Cancel", "Confirm", "Continue", "Next", "Primary", "Secondary", "Submit", "Tertiary"];
var deprecations = [{
	variants: ["Confirm", "Continue", "Next", "Submit"],
	replacements: {
		name: "NavigationButton",
		path: "Navigation/Buttons",
		variant: "Primary"
	}
}, {
	variants: ["Back"],
	replacements: {
		name: "NavigationButton",
		path: "Navigation/Buttons",
		variant: "Secondary"
	}
}, {
	variants: ["Cancel"],
	replacements: {
		name: "NavigationButton",
		path: "Navigation/Buttons",
		variant: "Tertiary"
	}
}];
var packageJson = {
	main: main,
	variants: variants,
	"component-id": 812,
	"component-life-cycle": "active",
	"is-bespoke": false,
	deprecations: deprecations
};

var getLabelText = function getLabelText(label, labelText) {
	if (label === undefined) {
		return labelText;
	}

	DeprecationWarnings.logProp(packageJson, 'label prop deprecated in favour of labelText prop.');
	return label;
};

var _extends$3 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$2(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var LoadingOutlineSmallIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$2(_ref, ["styles"]);

  return React.createElement("svg", _extends$3({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props), React.createElement("path", { d: "M17.62 6.306L15.406 8.52a4.87 4.87 0 1 0 0 6.96l2.214 2.214a8 8 0 1 1 0-11.388z" }));
});

var _extends$4 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$3(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$3(_ref, ["styles"]);

  return React.createElement("svg", _extends$4({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M84 96H56c-.238 0-.475-.02-.709-.062a31.449 31.449 0 0 1-2.518-.56A17.923 17.923 0 0 1 48 93.325a18.772 18.772 0 0 1-7.377 2.63c-.168.019-.453.046-.623.046H12a4 4 0 0 1-4-4V44a8.21 8.21 0 0 1 8-8h8V24C24 10.745 34.745 0 48 0s24 10.745 24 24v8h-8v-8c0-8.837-7.163-16-16-16s-16 7.163-16 16v16a3.999 3.999 0 0 1-4 4H16v44h23.74a10.522 10.522 0 0 0 2.153-.55 21.577 21.577 0 0 1-.825-1.317L34.23 74.246a15.892 15.892 0 0 1 13.846-23.754h.002a15.866 15.866 0 0 1 13.793 23.781l-6.91 11.899c-.252.437-.52.86-.8 1.273.216.075.435.141.655.2.504.132 1.022.254 1.555.355H80V44H36v-8h44a8.21 8.21 0 0 1 8 8v48a4 4 0 0 1-4 4zM48.074 58.492a7.937 7.937 0 0 0-6.135 2.89 7.824 7.824 0 0 0-.775 8.872l6.838 11.886.025.043.016-.027 6.908-11.898a7.825 7.825 0 0 0-.736-8.875 7.95 7.95 0 0 0-6.14-2.891z" }));
});

var _extends$5 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$4(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$1 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$4(_ref, ["styles"]);

  return React.createElement("svg", _extends$5({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7.932 9c-.305 0-.552.223-.552.5v3c0 .276.247.5.552.5.305 0 .553-.224.553-.5v-3c0-.277-.248-.5-.553-.5zm6.078 5c0 .552-.495 1-1.105 1H2.96c-.61 0-1.105-.448-1.105-1V8c0-.552.494-1 1.105-1h9.945c.61 0 1.105.448 1.105 1v6zM4.065 4.5c0-1.933 1.732-3.5 3.867-3.5C10.068 1 11.8 2.567 11.8 4.5V6H4.065V4.5zm8.84 1.5V4.5c0-2.485-2.226-4.5-4.973-4.5C5.186 0 2.96 2.015 2.96 4.5V6C1.74 6 .75 6.895.75 8v6c0 1.104.99 2 2.21 2h9.945c1.22 0 2.21-.896 2.21-2V8c0-1.105-.99-2-2.21-2z" }));
});

var getLockOutlineLarge = getThemeIcon(VMIcon$1, GenericIcon$1);

var INTERNET_BANKING_CSS_OVERRIDE = '!important';

var main$1 = "ProminentLabel.js";
var packageJson$1 = {
	main: main$1,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$5 = taggedTemplateLiteral(['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledProminentLabel = styled('div')(_templateObject$5, function (props) {
	return props.theme.isCompact ? useFontSize.of.jura() : useFontSize.of.arran();
}, function (props) {
	return props.theme.fonts.display.bold;
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var ProminentLabel = function ProminentLabel(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$1, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledProminentLabel,
			{ isFlush: isFlush },
			children
		)
	);
};

ProminentLabel.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool
};

ProminentLabel.defaultProps = {
	isFlush: false
};

var main$2 = "StandardLabel.js";
var packageJson$2 = {
	main: main$2,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$6 = taggedTemplateLiteral(['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n'], ['\n\t', ';\n\tfont-family: ', ';\n\t', ';\n\n\t@media print {\n\t\tfont-size: 16px;\n\t}\n']);

var StyledStandardLabel = styled('div')(_templateObject$6, function (props) {
	return props.theme.isCompact ? useFontSize.of.bute() : useFontSize.of.jura();
}, function (props) {
	return props.theme.fonts.standardLabel;
}, function (props) {
	return !props.isFlush && '' + externalMarginRegular;
});

var StandardLabel = function StandardLabel(_ref) {
	var isFlush = _ref.isFlush,
	    children = _ref.children,
	    dataTestId = _ref['data-test-id'],
	    id = _ref.id;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$2, hasCustomMargins: true, layout: 'typography' },
		React.createElement(
			StyledStandardLabel,
			{ isFlush: isFlush, 'data-test-id': dataTestId, id: id },
			children
		)
	);
};

StandardLabel.propTypes = {
	/** Allows for content to be text or node (for example IconTextDynamic). */
	children: PropTypes.node.isRequired,
	/** Removed margins. */
	isFlush: PropTypes.bool,
	/** Data attribute targeting modal container for automation test purposes. */
	'data-test-id': PropTypes.string,
	/** String id passed to underlying html element. */
	id: PropTypes.string
};

StandardLabel.defaultProps = {
	isFlush: false,
	'data-test-id': 'standard-label'
};

var _templateObject$7 = taggedTemplateLiteral(['\n\tmargin-right: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\twidth: 24px;\n\t}\n'], ['\n\tmargin-right: ', ';\n\n\tsvg {\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\twidth: 24px;\n\t}\n']),
    _templateObject2$4 = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tdisplay: inline-flex;\n\tpadding: ', ' ', ';\n\tposition: fixed;\n\tright: ', ';\n\ttop: ', ';\n\ttransition: right 0.5s ease-in-out;\n'], ['\n\talign-items: center;\n\tbackground: ', ';\n\tborder: 1px solid ', ';\n\tborder-radius: ', ';\n\tdisplay: inline-flex;\n\tpadding: ', ' ', ';\n\tposition: fixed;\n\tright: ', ';\n\ttop: ', ';\n\ttransition: right 0.5s ease-in-out;\n']);

var StyledIconWrapper = styled$1('div')(_templateObject$7, spacing.SINGLE, function (props) {
	return props.iconColour;
});

var StyledWrapper$1 = styled$1('div')(_templateObject2$4, colours.component.background, function (props) {
	return props.borderColour;
}, function (props) {
	return props.theme.borderRadiusLarger;
}, spacing.DOUBLE, spacing.TRIPLE, function (props) {
	return props.isVisible ? spacing.DOUBLE : '-75vw';
}, spacing.DOUBLE);

var BaseToast = function BaseToast(_ref) {
	var borderColour = _ref.borderColour,
	    icon = _ref.icon,
	    iconColour = _ref.iconColour,
	    isVisible = _ref.isVisible,
	    messageText = _ref.messageText;
	return React.createElement(
		StyledWrapper$1,
		{ borderColour: borderColour, isVisible: isVisible },
		icon && React.createElement(
			StyledIconWrapper,
			{ iconColour: iconColour },
			icon
		),
		React.createElement(
			ProminentLabel,
			{ isFlush: true },
			React.createElement(
				'span',
				null,
				messageText
			)
		)
	);
};

BaseToast.propTypes = {
	/** Border colour. */
	borderColour: PropTypes.string,
	/** Icon shown to the left of the message text. */
	icon: PropTypes.node,
	/** Icon fill colour. */
	iconColour: PropTypes.string,
	/** Character count as number. */
	isVisible: PropTypes.bool.isRequired,
	/** Message text. */
	messageText: PropTypes.string.isRequired
};

BaseToast.defaultProps = {
	borderColour: 'hsl(0, 0%, 0%)'
};

var InternalLockedToast = function InternalLockedToast(_ref) {
	var isVisible = _ref.isVisible,
	    theme = _ref.theme;

	var PadlockIcon = getLockOutlineLarge(theme.name);

	return React.createElement(BaseToast, {
		borderColour: colours.component.locked,
		icon: React.createElement(PadlockIcon, null),
		iconColour: colours.component.locked,
		isVisible: isVisible,
		messageText: 'Feature is locked.'
	});
};

InternalLockedToast.propTypes = {
	/** Makes the toast visible. */
	isVisible: PropTypes.bool.isRequired
};

InternalLockedToast.defaultProps = {
	borderColour: 'hsl(0, 0%, 0%)'
};

var WrappedInternalLockedToast = withTheme(InternalLockedToast);

var _templateObject$8 = taggedTemplateLiteral(['\n\tsvg {\n\t\t', '\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tmargin-right: ', ';\n\t\ttransition: fill 0.2s ease-in-out;\n\t\twidth: 24px;\n}\n'], ['\n\tsvg {\n\t\t', '\n\t\tfill: ', ';\n\t\theight: 24px;\n\t\tmargin-right: ', ';\n\t\ttransition: fill 0.2s ease-in-out;\n\t\twidth: 24px;\n}\n']),
    _templateObject2$5 = taggedTemplateLiteral(['\n\tdisplay: inline-flex;\n\tmargin-left: ', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\tmargin-right: 0;\n\t\twidth: 16px;\n\t}\n'], ['\n\tdisplay: inline-flex;\n\tmargin-left: ', ';\n\n\t> svg {\n\t\tfill: ', ';\n\t\theight: 16px;\n\t\tmargin-right: 0;\n\t\twidth: 16px;\n\t}\n']),
    _templateObject3$3 = taggedTemplateLiteral(['\n\talign-items: center;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\t', '\n\tmax-width: 100%;\n\tpadding: ', ' ', ';\n\ttransition: all 0.15s;\n\ttext-align: left;\n\t', '\n\t', '\n\t', '\n\t', ';\n'], ['\n\talign-items: center;\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\t', '\n\tmax-width: 100%;\n\tpadding: ', ' ', ';\n\ttransition: all 0.15s;\n\ttext-align: left;\n\t', '\n\t', '\n\t', '\n\t', ';\n']);

var getPrimaryHoverStyles = function getPrimaryHoverStyles(props) {
	if (!props.isLoading && !props.isLocked) {
		return '&:hover {\n\t\t\tbackground-color: ' + props.theme.colours.secondaryAccent + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\t\t\tborder-color: ' + props.theme.colours.secondaryAccent + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\t\t}';
	}
	return '';
};

var getPrimaryBackgroundColour = function getPrimaryBackgroundColour(props) {
	var colour = props.theme.colours.primary;
	if (props.isLoading) {
		colour = props.theme.colours.disabledNavigationButton;
	} else if (props.isLocked) {
		colour = colours.component.locked;
	}
	return colour;
};

var primaryStyles = function primaryStyles(props) {
	return '\n\tbackground-color: ' + getPrimaryBackgroundColour(props) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\tborder: 2px solid ' + getPrimaryBackgroundColour(props) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\tborder-bottom-color: ' + (props.isLoading ? props.theme.colours.disabledNavigationButton + ' ' + INTERNET_BANKING_CSS_OVERRIDE : !props.isLocked && props.theme.colours.secondaryAccent + ' ' + INTERNET_BANKING_CSS_OVERRIDE) + ';\n\tcolor: ' + colours.generalPalette.white + ';\n\t' + getPrimaryHoverStyles(props) + '\n';
};

var getSecondaryHoverStyles = function getSecondaryHoverStyles(props) {
	if (!props.isLoading && !props.isLocked) {
		return '&:hover {\n            background-color: ' + props.theme.colours.primary + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n            color: ' + colours.generalPalette.white + ';\n\t\t}';
	}
	return '';
};

var getSecondaryBackgroundColour = function getSecondaryBackgroundColour(props) {
	var colour = colours.generalPalette.white;
	if (props.isLoading) {
		colour = props.theme.colours.disabledNavigationButton;
	} else if (props.isLocked) {
		colour = colours.component.locked;
	}
	return colour;
};

var getSecondaryBorderColour = function getSecondaryBorderColour(props) {
	var colour = props.theme.colours.primary;
	if (props.isLoading) {
		colour = props.theme.colours.disabledNavigationButton;
	} else if (props.isLocked) {
		colour = colours.component.locked;
	}
	return colour;
};

var getSecondaryColour = function getSecondaryColour(_ref) {
	var isLocked = _ref.isLocked,
	    isLoading = _ref.isLoading,
	    theme = _ref.theme;

	if (isLocked || isLoading) {
		return colours.generalPalette.white;
	}
	return theme.colours.primary;
};

var secondaryStyles = function secondaryStyles(props) {
	return '\n\tbackground-color: ' + getSecondaryBackgroundColour(props) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\tborder: 2px solid ' + getSecondaryBorderColour(props) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\tcolor: ' + getSecondaryColour(props) + ';\n\t' + getSecondaryHoverStyles(props) + '\n';
};

var getTertiaryHoverStyles = function getTertiaryHoverStyles(props) {
	if (!props.isLoading && !props.isLocked) {
		return '&:hover {\n            color: ' + props.theme.colours.secondaryAccent + ';\n\t\t}';
	}
	return '';
};

var getTertiaryColour = function getTertiaryColour(_ref2) {
	var isLocked = _ref2.isLocked,
	    isMonotone = _ref2.isMonotone,
	    theme = _ref2.theme;

	if (isLocked) {
		return colours.component.locked;
	}
	return isMonotone ? colours.generalPalette.black : theme.colours.primary;
};

var tertiaryStyles = function tertiaryStyles(props) {
	return '\n\tbackground: none ' + INTERNET_BANKING_CSS_OVERRIDE + ';;\n\tborder: 0 ' + INTERNET_BANKING_CSS_OVERRIDE + ';;\n\tcolor: ' + getTertiaryColour(props) + ';\n\tpadding: 0 ' + INTERNET_BANKING_CSS_OVERRIDE + ';;\n\ttext-decoration: underline;\n\theight: ' + (props.theme.isCompact ? 'auto' : '48px') + ';\n\n\t> div > div {\n\t\tfont-family: ' + props.theme.fonts.text.regular + ';\n\t}\n\n\t' + getTertiaryHoverStyles(props) + '\n';
};

var StyledLoadingIcon = styled('div')(_templateObject$8, function (props) {
	return props.isLoading && 'animation: spin 0.75s linear infinite;';
}, function (props) {
	return props.displayType === 'primary' || props.isLoading ? colours.generalPalette.white : props.theme.colours.primary;
}, spacing.SINGLE);

var StyledPadlockIcon = styled('div')(_templateObject2$5, spacing.HALF, function (props) {
	return props.displayType !== 'tertiary' ? colours.generalPalette.white : colours.component.locked;
});

var StyledButton$1 = styled('button')(_templateObject3$3, function (props) {
	return props.theme.borderRadius;
}, function (props) {
	return !props.isInline && '\n\t\t\tmargin-bottom: ' + (props.theme.isCompact ? spacing.SINGLE : spacing.DOUBLE) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\t\t\tmargin-right: ' + (props.theme.isCompact ? spacing.ONE_AND_HALF : spacing.TRIPLE) + ' ' + INTERNET_BANKING_CSS_OVERRIDE + ';\n\t';
}, function (props) {
	return props.theme.isCompact ? spacing.QUARTER + ' ' + spacing.SINGLE : spacing.SINGLE + ' ' + spacing.TRIPLE;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.displayType === 'primary' && primaryStyles(props);
}, function (props) {
	return props.displayType === 'secondary' && secondaryStyles(props);
}, function (props) {
	return props.displayType === 'tertiary' && tertiaryStyles(props);
}, function (props) {
	return props.hasFluidHeight && 'height: auto';
});

// eslint-disable-next-line react/prop-types

var UnwrappedNavigationButtonBase = function (_Component) {
	inherits(UnwrappedNavigationButtonBase, _Component);

	function UnwrappedNavigationButtonBase(props) {
		classCallCheck(this, UnwrappedNavigationButtonBase);

		var _this = possibleConstructorReturn(this, (UnwrappedNavigationButtonBase.__proto__ || Object.getPrototypeOf(UnwrappedNavigationButtonBase)).call(this, props));

		_this.state = {
			isVisible: false
		};
		return _this;
	}

	createClass(UnwrappedNavigationButtonBase, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    dataTestId = _props['data-test-id'],
			    display = _props.display,
			    hasFluidHeight = _props.hasFluidHeight,
			    isInline = _props.isInline,
			    isLoading = _props.isLoading,
			    isLocked = _props.isLocked,
			    isMonotone = _props.isMonotone,
			    labelText = _props.labelText,
			    loadingText = _props.loadingText,
			    onClick = _props.onClick,
			    theme = _props.theme,
			    willSubmitForm = _props.willSubmitForm,
			    ariaLabelledBy = _props['aria-labelledby'],
			    ariaLabel = _props['aria-label'];
			var isVisible = this.state.isVisible;

			var PadlockIcon = getLockOutlineLarge(theme.name);
			var threeSeconds = 3000;

			var popToast = function popToast() {
				_this2.setState(function () {
					return { isVisible: true };
				});

				// Load data / make the call. Spoofed here for demo purposes.
				setTimeout(function () {
					_this2.setState(function () {
						return { isVisible: false };
					});
				}, threeSeconds);
			};

			return React.createElement(
				'div',
				null,
				React.createElement(
					StyledButton$1,
					{
						'data-test-id': dataTestId,
						disabled: isLoading,
						displayType: display,
						hasFluidHeight: hasFluidHeight,
						isInline: isInline,
						isLoading: isLoading,
						isLocked: isLocked,
						isMonotone: isMonotone,
						loadingText: true,
						onClick: isLocked ? popToast : onClick,
						type: willSubmitForm ? 'submit' : 'button',
						'aria-labelledby': ariaLabelledBy,
						'aria-label': ariaLabel
					},
					isLoading && React.createElement(
						StyledLoadingIcon,
						{ isLoading: isLoading },
						React.createElement(LoadingOutlineSmallIcon, null)
					),
					React.createElement(
						StandardLabel,
						{ isFlush: true },
						React.createElement(
							'span',
							null,
							isLoading ? loadingText : labelText
						)
					),
					isLocked && React.createElement(
						StyledPadlockIcon,
						{ displayType: display, isLocked: isLocked },
						React.createElement(PadlockIcon, null)
					)
				),
				React.createElement(WrappedInternalLockedToast, { isVisible: isVisible })
			);
		}
	}]);
	return UnwrappedNavigationButtonBase;
}(Component);

UnwrappedNavigationButtonBase.propTypes = _extends({}, baseProps);

var NavigationButtonBase = withTheme(UnwrappedNavigationButtonBase);

var baseProps = {
	/** Data attribute available for automated test targeting. */
	'data-test-id': PropTypes.string,
	/** Locks the component with associated toast message on click. For Advisor system use only. */
	isLocked: PropTypes.bool,
	/** Button text. */
	labelText: PropTypes.string.isRequired,
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Aria-labelledby */
	'aria-labelledby': PropTypes.string,
	/** Aria-label */
	'aria-label': PropTypes.string
};

NavigationButtonBase.propTypes = _extends({}, baseProps, {
	/** Sets the display type, controls the styling. */
	display: PropTypes.oneOf(['primary', 'secondary', 'tertiary']).isRequired,
	/** Boolean to override the static button height. */
	hasFluidHeight: PropTypes.bool,
	/** Removed margins. */
	isInline: PropTypes.bool,
	/** Shows the loading spinner and loading text when true. */
	isLoading: PropTypes.bool,
	/** Changes the component colour to be monotone. For Advisor system use only. */
	isMonotone: PropTypes.bool,
	/** Sets the text when the isLoading prop is set to true. */
	loadingText: PropTypes.string,
	/** When set, will change button type from 'button' to 'submit'. */
	willSubmitForm: PropTypes.bool
});

NavigationButtonBase.defaultProps = {
	hasFluidHeight: false,
	isInline: false,
	isLoading: false,
	isLocked: false,
	isMonotone: false,
	loadingText: 'Loading',
	willSubmitForm: false
};

var primaryVariantProps = _extends({}, baseProps, {
	/** Shows the loading spinner and loading text when true. */
	isLoading: PropTypes.bool,
	/** Sets the text when the isLoading prop is set to true. */
	loadingText: PropTypes.string,
	/** Changes button type from 'button' to 'submit'. */
	willSubmitForm: PropTypes.bool
});

var Primary = function Primary(_ref) {
	var dataTestId = _ref['data-test-id'],
	    isLoading = _ref.isLoading,
	    isLocked = _ref.isLocked,
	    loadingText = _ref.loadingText,
	    label = _ref.label,
	    labelText = _ref.labelText,
	    onClick = _ref.onClick,
	    willSubmitForm = _ref.willSubmitForm,
	    variant = _ref.variant,
	    ariaLabelledBy = _ref['aria-labelledby'],
	    ariaLabel = _ref['aria-label'];

	var finalLabelText = getLabelText(label, labelText);
	return React.createElement(
		InternalComponentFrame,
		{ variant: variant, packageJson: packageJson, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(NavigationButtonBase, {
			'data-test-id': dataTestId,
			display: 'primary',
			isLoading: isLoading,
			isLocked: isLocked,
			labelText: finalLabelText,
			loadingText: loadingText,
			onClick: onClick,
			willSubmitForm: willSubmitForm,
			'aria-labelledby': ariaLabelledBy,
			'aria-label': ariaLabel
		})
	);
};

Primary.propTypes = _extends({}, primaryVariantProps, {
	/** legacy button text prop. */
	label: PropTypes.string,
	variant: PropTypes.string
});

Primary.defaultProps = {
	'data-test-id': 'navigation-button-primary',
	variant: 'Primary'
};

var secondaryVariantProps = _extends({}, baseProps, {
	/** Shows the loading spinner and loading text when true. */
	isLoading: PropTypes.bool,
	/** Sets the text when the isLoading prop is set to true. */
	loadingText: PropTypes.string
});

var Secondary = function Secondary(_ref) {
	var dataTestId = _ref['data-test-id'],
	    isLoading = _ref.isLoading,
	    isLocked = _ref.isLocked,
	    loadingText = _ref.loadingText,
	    label = _ref.label,
	    labelText = _ref.labelText,
	    onClick = _ref.onClick,
	    variant = _ref.variant,
	    ariaLabelledBy = _ref['aria-labelledby'],
	    ariaLabel = _ref['aria-label'];

	var finalLabelText = getLabelText(label, labelText);
	return React.createElement(
		InternalComponentFrame,
		{ variant: variant, packageJson: packageJson, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(NavigationButtonBase, {
			'data-test-id': dataTestId,
			display: 'secondary',
			isLoading: isLoading,
			isLocked: isLocked,
			labelText: finalLabelText,
			loadingText: loadingText,
			onClick: onClick,
			'aria-labelledby': ariaLabelledBy,
			'aria-label': ariaLabel
		})
	);
};

Secondary.propTypes = _extends({}, secondaryVariantProps, {
	/** legacy button text prop. */
	label: PropTypes.string,
	variant: PropTypes.string
});

Secondary.defaultProps = {
	'data-test-id': 'navigation-button-secondary',
	variant: 'Secondary'
};

var tertiaryVariantProps = _extends({}, baseProps, {
	/** Removed margins. */
	isInline: PropTypes.bool,
	/** Changes the component colour to be monotone. For Advisor system use only. */
	isMonotone: PropTypes.bool
});

var Tertiary = function Tertiary(_ref) {
	var dataTestId = _ref['data-test-id'],
	    isInline = _ref.isInline,
	    isLocked = _ref.isLocked,
	    isMonotone = _ref.isMonotone,
	    label = _ref.label,
	    labelText = _ref.labelText,
	    onClick = _ref.onClick,
	    willSubmitForm = _ref.willSubmitForm,
	    variant = _ref.variant,
	    ariaLabelledBy = _ref['aria-labelledby'],
	    ariaLabel = _ref['aria-label'];

	var finalLabelText = getLabelText(label, labelText);
	return React.createElement(
		InternalComponentFrame,
		{ variant: variant, packageJson: packageJson, hasCustomMargins: true, layout: 'inline-block' },
		React.createElement(NavigationButtonBase, {
			'data-test-id': dataTestId,
			display: 'tertiary',
			hasFluidHeight: true,
			isInline: isInline,
			isLocked: isLocked,
			isMonotone: isMonotone,
			labelText: finalLabelText,
			onClick: onClick,
			willSubmitForm: willSubmitForm,
			'aria-labelledby': ariaLabelledBy,
			'aria-label': ariaLabel
		})
	);
};

Tertiary.propTypes = _extends({}, tertiaryVariantProps, {
	/** legacy button text prop. */
	label: PropTypes.string
});

Tertiary.defaultProps = {
	'data-test-id': 'navigation-button-tertiary',
	variant: 'Tertiary'
};

var Back = function Back(_ref) {
	var dataTestId = _ref['data-test-id'],
	    isLoading = _ref.isLoading,
	    labelText = _ref.labelText,
	    loadingText = _ref.loadingText,
	    onClick = _ref.onClick,
	    ariaLabelledBy = _ref['aria-labelledby'],
	    ariaLabel = _ref['aria-label'];
	return React.createElement(NavigationButton.Secondary, {
		variant: 'Back',
		'data-test-id': dataTestId,
		display: 'secondary',
		isLoading: isLoading,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		'aria-label': ariaLabel,
		'aria-labelledby': ariaLabelledBy
	});
};

Back.propTypes = _extends({}, secondaryVariantProps);

Back.defaultProps = {
	'data-test-id': 'navigation-button-back',
	labelText: 'Back',
	variant: 'Back'
};

var Cancel = function Cancel(_ref2) {
	var dataTestId = _ref2['data-test-id'],
	    labelText = _ref2.labelText,
	    onClick = _ref2.onClick,
	    ariaLabelledBy = _ref2['aria-labelledby'],
	    ariaLabel = _ref2['aria-label'];
	return React.createElement(NavigationButton.Tertiary, {
		variant: 'Cancel',
		'data-test-id': dataTestId,
		display: 'tertiary',
		labelText: labelText,
		onClick: onClick,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Cancel.propTypes = _extends({}, tertiaryVariantProps);

Cancel.defaultProps = {
	'data-test-id': 'navigation-button-cancel',
	labelText: 'Cancel',
	variant: 'Cancel'
};

var Confirm = function Confirm(_ref3) {
	var dataTestId = _ref3['data-test-id'],
	    isLoading = _ref3.isLoading,
	    isLocked = _ref3.isLocked,
	    labelText = _ref3.labelText,
	    loadingText = _ref3.loadingText,
	    onClick = _ref3.onClick,
	    willSubmitForm = _ref3.willSubmitForm,
	    ariaLabelledBy = _ref3['aria-labelledby'],
	    ariaLabel = _ref3['aria-label'];
	return React.createElement(NavigationButton.Primary, {
		variant: 'Confirm',
		'data-test-id': dataTestId,
		display: 'primary',
		isLoading: isLoading,
		isLocked: isLocked,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		willSubmitForm: willSubmitForm,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Confirm.propTypes = _extends({}, primaryVariantProps);

Confirm.defaultProps = {
	'data-test-id': 'navigation-button-confirm',
	labelText: 'Confirm',
	variant: 'Confirm'
};

var Continue = function Continue(_ref4) {
	var dataTestId = _ref4['data-test-id'],
	    isLoading = _ref4.isLoading,
	    isLocked = _ref4.isLocked,
	    labelText = _ref4.labelText,
	    loadingText = _ref4.loadingText,
	    onClick = _ref4.onClick,
	    willSubmitForm = _ref4.willSubmitForm,
	    ariaLabelledBy = _ref4['aria-labelledby'],
	    ariaLabel = _ref4['aria-label'];
	return React.createElement(NavigationButton.Primary, {
		variant: 'Continue',
		'data-test-id': dataTestId,
		display: 'primary',
		isLoading: isLoading,
		isLocked: isLocked,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		willSubmitForm: willSubmitForm,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Continue.propTypes = _extends({}, primaryVariantProps);

Continue.defaultProps = {
	'data-test-id': 'navigation-button-continue',
	labelText: 'Continue',
	variant: 'Continue'
};

var Next = function Next(_ref5) {
	var dataTestId = _ref5['data-test-id'],
	    isLoading = _ref5.isLoading,
	    isLocked = _ref5.isLocked,
	    labelText = _ref5.labelText,
	    loadingText = _ref5.loadingText,
	    onClick = _ref5.onClick,
	    willSubmitForm = _ref5.willSubmitForm,
	    ariaLabelledBy = _ref5['aria-labelledby'],
	    ariaLabel = _ref5['aria-label'];
	return React.createElement(NavigationButton.Primary, {
		variant: 'Next',
		'data-test-id': dataTestId,
		display: 'primary',
		isLoading: isLoading,
		isLocked: isLocked,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		willSubmitForm: willSubmitForm,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Next.propTypes = _extends({}, primaryVariantProps);

Next.defaultProps = {
	'data-test-id': 'navigation-button-next',
	labelText: 'Next',
	variant: 'Next'
};

var Submit = function Submit(_ref6) {
	var dataTestId = _ref6['data-test-id'],
	    isLoading = _ref6.isLoading,
	    isLocked = _ref6.isLocked,
	    labelText = _ref6.labelText,
	    loadingText = _ref6.loadingText,
	    onClick = _ref6.onClick,
	    willSubmitForm = _ref6.willSubmitForm,
	    ariaLabelledBy = _ref6['aria-labelledby'],
	    ariaLabel = _ref6['aria-label'];
	return React.createElement(NavigationButton.Primary, {
		variant: 'Submit',
		'data-test-id': dataTestId,
		display: 'primary',
		isLoading: isLoading,
		isLocked: isLocked,
		labelText: labelText,
		loadingText: loadingText,
		onClick: onClick,
		willSubmitForm: willSubmitForm,
		'aria-labelledby': ariaLabelledBy,
		'aria-label': ariaLabel
	});
};

Submit.propTypes = _extends({}, primaryVariantProps);

Submit.defaultProps = {
	'data-test-id': 'navigation-button-submit',
	labelText: 'Submit',
	variant: 'Submit'
};

var NavigationButton = {
	Back: Back,
	Cancel: Cancel,
	Confirm: Confirm,
	Continue: Continue,
	Next: Next,
	Primary: Primary,
	Secondary: Secondary,
	Submit: Submit,
	Tertiary: Tertiary
};

var main$3 = "NavigationButtonGroup.js";
var packageJson$3 = {
	main: main$3,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$9 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmargin-top: ', ';\n'], ['\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tmargin-top: ', ';\n']),
    _templateObject2$6 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-basis: 100%;\n'], ['\n\tdisplay: flex;\n\tflex-basis: 100%;\n']);

var StyledWrapper$2 = styled('div')(_templateObject$9, spacing.DOUBLE);

var StyledTertiaryButtons = styled('div')(_templateObject2$6);

var NavigationButtonGroup = function NavigationButtonGroup(_ref) {
	var primaryButton = _ref.primaryButton,
	    secondaryButtons = _ref.secondaryButtons,
	    tertiaryButtons = _ref.tertiaryButtons;
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$3, hasCustomMargins: true, layout: 'container' },
		React.createElement(
			StyledWrapper$2,
			null,
			secondaryButtons,
			primaryButton,
			tertiaryButtons && React.createElement(
				StyledTertiaryButtons,
				null,
				tertiaryButtons
			)
		)
	);
};

NavigationButtonGroup.propTypes = {
	/** Primary button as single component. */
	primaryButton: PropTypes.node.isRequired,
	/** Secondary button as a single component or an array of multple buttons.
  * When passed as an array provide a key for each component.
  */
	secondaryButtons: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
	/** Tertiary button as a single component or an array of multple buttons.
  * When passed as an array provide a key for each component.
  */
	tertiaryButtons: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};

NavigationButtonGroup.defaultProps = {};

var _extends$6 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$5(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMHealthIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$5(_ref, ["styles"]);

  return React.createElement("svg", _extends$6({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M68 0c16.293 0 28 13.099 27.999 30.102-.186 7.302-2.129 14.452-5.618 20.761l-1.507 2.886-7.091-3.704 2.253-4.299A37.352 37.352 0 0 0 88 30c0-12.671-8.338-22-20-22-5.478 0-10.444 2.094-14.419 5.267C57.66 18.709 60 25.137 60 31.163c0 17.942-24 17.942-24 .014-.02-6.014 2.357-12.46 6.482-17.922C38.516 10.086 33.54 8 28 8 16.338 8 8 17.329 7.996 29.83c.838 19.746 14.142 38.062 39.727 57.015l4.718-4.313c4.757-4.372 8.287-7.702 11.309-10.71l.688-.689a183.18 183.18 0 0 0 2.297-2.349l1.463-1.543 2.443-2.66 5.944 5.354c-.605.672-1.205 1.33-1.808 1.98l-.724.778c-3.751 4.008-7.704 7.868-13.669 13.396l-2.554 2.356-7.14 6.515a4 4 0 0 1-5.026.287C16.578 74.321.996 53.577 0 30 0 13.099 11.707 0 28 0c7.79 0 14.673 2.941 20.04 7.421C53.419 2.945 60.289 0 68 0zm-2.764 37.386a4.4 4.4 0 0 1 3.867 2.125L79.65 56.979H96v8H77.618a4.4 4.4 0 0 1-3.767-2.125l-8.344-13.82-13.583 25.099a4.4 4.4 0 0 1-4.123 2.298c-1.704-.098-3.198-1.173-3.773-2.619l-5.237-11.78-1.649 2.947h-9.679v-8h4.988l2.868-5.127a4.4 4.4 0 0 1 7.86.36l5.191 11.68L61.467 39.69a4.403 4.403 0 0 1 3.769-2.305zM48.023 19.281l-.618.954c-2.182 3.53-3.417 7.386-3.405 10.928 0 7.276 8 7.276 8 0 0-3.884-1.446-8.113-3.977-11.882z" }));
});

var _extends$7 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$6(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var CYBGPlusIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$6(_ref, ["styles"]);

  return React.createElement("svg", _extends$7({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M7 7V4h2v3h3v2H9v3H7V9H4V7h3zm1 9A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm0-1A7 7 0 1 0 8 1a7 7 0 0 0 0 14z" }));
});

var _extends$8 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$7(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$7(_ref, ["styles"]);

  return React.createElement("svg", _extends$8({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M60 5.307a8.008 8.008 0 0 1 8 8v4h20a8.008 8.008 0 0 1 8 8v56a8.008 8.008 0 0 1-8 8H60.64c-.119 0-.347-.016-.464-.025a28.474 28.474 0 0 1-11.59-3.559 28.6 28.6 0 0 1-11.602 3.568L8 89.307a8.008 8.008 0 0 1-8-8v-56a8.008 8.008 0 0 1 8-8h16v8H8v56h28.64a19.259 19.259 0 0 0 4.798-1.072 15.636 15.636 0 0 1-4.506-8.614 12.427 12.427 0 0 1 3.162-10.8c4.748-4.533 12.221-4.532 16.968.002 4.74 4.95 4.91 12.7.393 17.853a18.11 18.11 0 0 1-1.498 1.612c1.59.539 3.24.883 4.912 1.023L88 81.307v-56H60v-12H36v4h18.686v8H28v-12a8.008 8.008 0 0 1 8-8zm-11.424 60a3.965 3.965 0 0 0-2.826 1.172 4.819 4.819 0 0 0-.904 3.961 8 8 0 0 0 2.869 4.717l.902.777a12.052 12.052 0 0 0 2.535-2.18 5.46 5.46 0 0 0 .246-7.28 3.968 3.968 0 0 0-2.822-1.167zm29.395-32.69v42.294h-8V32.618zm-52 0v42.294h-8V32.618z" }));
});

var _extends$9 = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$8(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$2 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$8(_ref, ["styles"]);

  return React.createElement("svg", _extends$9({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon briefcase"), React.createElement("path", { d: "M10 6V3.998A2 2 0 0 1 11.982 2h8.037C21.112 2 22 2.885 22 3.998V6h2V4.99c0-.546.432-.99.992-.99h4.018c.547 0 .99.432.99.99V6c1.106 0 2 .912 2 2.005v19.99A1.997 1.997 0 0 1 30 30H2c-1.104 0-2-.912-2-2.005V8.005C0 6.898.888 6 2 6V4.99c0-.546.432-.99.99-.99h4.02c.546 0 .99.432.99.99V6h2zm2-2v2h8V4h-8zM2 8v20h2V8H2zm26 0v20h2V8h-2zM6 8v20h20V8H6z" }));
});

var getBriefcaseOutlineLarge = getThemeIcon(VMIcon$2, GenericIcon$2);

var _extends$a = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$9(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$9(_ref, ["styles"]);

  return React.createElement("svg", _extends$a({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon building"), React.createElement("path", { d: "M20 30h2V2H10v28h2v-6h8v6zM8 6V0h16v6h8v26H0V6h8zm16 2v22h6V8h-6zM2 30h6V8H2v22zm12-4v4h4v-4h-4zM12 6h8v2h-8V6zm0 6h8v2h-8v-2zm0 6h8v2h-8v-2zm-8-6h2v2H4v-2zm22 0h2v2h-2v-2zM4 18h2v2H4v-2zm22 0h2v2h-2v-2zM4 24h2v2H4v-2zm22 0h2v2h-2v-2z" }));
});

var _extends$b = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$a(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$3 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$a(_ref, ["styles"]);

  return React.createElement("svg", _extends$b({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M20 15v8H8v64h28.082a19.278 19.278 0 0 0 4.797-1.072 15.64 15.64 0 0 1-4.508-8.61 12.09 12.09 0 0 1 3.008-10.642c.107-.12.22-.232.34-.338a12.04 12.04 0 0 1 16.531-.057c4.933 4.923 5.217 12.824.649 18.088a18.43 18.43 0 0 1-1.5 1.614c1.59.538 3.24.88 4.914 1.021L88 87V23H76v-8h16a4 4 0 0 1 4 4v68a8.01 8.01 0 0 1-8 8H60.082c-.117 0-.348-.016-.465-.025a28.474 28.474 0 0 1-11.59-3.559 28.58 28.58 0 0 1-11.601 3.568L8 95a8.01 8.01 0 0 1-8-8V19.512A4.516 4.516 0 0 1 4.512 15zm28.004 56.004a3.993 3.993 0 0 0-2.824 1.191 4.143 4.143 0 0 0-.895 3.942 8.036 8.036 0 0 0 2.871 4.715l.903.777a12.198 12.198 0 0 0 2.539-2.184 5.464 5.464 0 0 0 .242-7.279 3.993 3.993 0 0 0-2.836-1.162zM72-1v80h-8V7H32v72h-8V-1zM20 63v8h-8v-8zm64 0v8h-8v-8zM20 47v8h-8v-8zm64 0v8h-8v-8zm-28 0v8H40v-8zM20 31v8h-8v-8zm64 0v8h-8v-8zm-28 0v8H40v-8zm0-16v8H40v-8z" }));
});

var getBuildingOutlineLarge = getThemeIcon(VMIcon$3, GenericIcon$3);

var _extends$c = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$b(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$4 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$b(_ref, ["styles"]);

  return React.createElement("svg", _extends$c({ xmlns: "http://www.w3.org/2000/svg", width: "32", height: "32", viewBox: "0 0 32 32" }, props), React.createElement("title", null, "icon clipboard tick"), React.createElement("path", { d: "M22 4h2v2h6v26H2V6h6V4h2V2.02C10 .903 10.902 0 11.982 0h8.037C21.112 0 22 .887 22 2.02V4zm-2 2V2h-8v4h-2v4h12V6h-2zM8 12V8H4v22h24V8h-4v4H8zm3.707 8.536L14.07 22.9l6.608-6.607a1 1 0 0 1 1.414 1.414l-7.314 7.314a.997.997 0 0 1-1.414 0l-3.07-3.07a1 1 0 1 1 1.413-1.414z" }));
});

var getClipboardTickOutlineLarge = getThemeIcon(GenericIcon$4, GenericIcon$4);

var _extends$d = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$c(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$5 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$c(_ref, ["styles"]);

  return React.createElement("svg", _extends$d({ xmlns: "http://www.w3.org/2000/svg", width: "96", height: "96", viewBox: "0 0 96 96" }, props), React.createElement("path", { d: "M0 28.636c0-9.129 4.05-13.693 12.15-13.693h70.057C91.402 14.943 96 19.22 96 27.775v39.716c0 9.063-4.598 13.594-13.793 13.594H12.15c-8.1 0-12.15-4.05-12.15-12.15V28.637zm6 3.516V65.14c0 6.63 3.544 9.945 10.631 9.945h61.3C85.977 75.085 90 71.376 90 63.957v-32.51c0-7.003-4.023-10.504-12.069-10.504h-61.3C9.544 20.943 6 24.679 6 32.152z" }), React.createElement("path", { d: "M75.5 60.43a5 5 0 1 1 0 7.141 5 5 0 1 1 0-7.141zM90 31H6v8.999h84zM13 53.001h50v-6.004H13z" }));
});

var _extends$e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$d(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$4 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$d(_ref, ["styles"]);

  return React.createElement("svg", _extends$e({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M92 14a4 4 0 0 1 4 4v32.782a8 8 0 0 1-2.343 5.657l-1.253 1.254 1.253 1.254A8 8 0 0 1 96 64.603V78a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V18a4 4 0 0 1 4-4zm-4 8H8v52h80v-9.397l-1.252-1.255-1.756 1.754c-3.852 4.03-10.03 4.623-14.662 1.421l-.622-.46a11.002 11.002 0 0 1-3.861-8.37c0-3.221 1.411-6.28 3.977-8.465a11.296 11.296 0 0 1 14.594.496l.54.523 1.786 1.785L88 50.782zM32 58v8H16v-8zm20 0v8H36v-8zm22.9-2.59a3.001 3.001 0 0 0-1.053 2.283c0 .879.385 1.713.938 2.189 1.212.958 2.906.935 4.134-.049l.354-.323 1.817-1.818-1.88-1.88c-1.175-1.229-3.091-1.362-4.31-.403zM52 46v8H16v-8zm28-16v8H16v-8z" }));
});

var getCreditCardOutlineLarge = getThemeIcon(VMIcon$4, GenericIcon$5);

var _extends$f = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$e(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$5 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$e(_ref, ["styles"]);

  return React.createElement("svg", _extends$f({ height: "72", viewBox: "0 0 96 72", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M55.384 0c7.252 0 12.924 5.507 12.924 12.923 0 4.15-2.197 8.172-6.464 13.521C58.67 30.04 54.828 33 50.343 35.323c.03.177.06.356.092.536.567 5.4-.2 11.844-1.967 17.478l12.266 6.133c8.659 4.349 11.26 5.146 18.65 5.146 2.235 0 5.956-.998 9.231-2.369V14.804c-4.32 1.455-8.43 1.811-14.769 1.811V9.231c7.784 0 11.281-.538 16.81-3.303C93.111 4.701 96 6.486 96 9.231v55.385a3.692 3.692 0 0 1-2.036 3.3C89.387 70.212 83.43 72 79.384 72c-8.74 0-12.368-1.111-21.958-5.928l-11.847-5.925a21.98 21.98 0 0 1-1.943 2.899C40.122 68.048 34.407 72 29.538 72c-8.5 0-14.77-6.264-14.77-12.917 0-7.308 4.95-12.929 14.77-12.929 2.16 0 4.382.495 6.821 1.408 1.625.607 3.18 1.324 5.39 2.436 1.108-3.922 1.665-8.256 1.469-11.934-4.806 1.073-9.839.601-15.006-1.387l2.652-6.892c4.026 1.55 7.742 1.854 11.258.948-1.003-6.645-1.507-11.958-1.507-15.97C40.615 5.948 47.495 0 55.385 0zM1.082 8.465c5.22-5.219 18.16-6.406 31.282-2.794l-1.96 7.12c-9.758-2.686-19.119-2.182-23.02.086v57.277H0V11.076c0-.98.39-1.918 1.082-2.61zM29.538 53.54c-5.518 0-7.384 2.12-7.384 5.544 0 2.573 2.96 5.533 7.384 5.533 2.047 0 5.789-2.588 8.193-5.999.422-.526.825-1.119 1.208-1.765l-.47-.238c-2.012-1.013-3.372-1.64-4.698-2.136-1.678-.628-3.075-.94-4.233-.94zM55.384 7.385c-4.03 0-7.384 2.9-7.384 7.377 0 3.178.369 7.42 1.12 12.783 2.746-1.67 5.11-3.632 7.069-5.845 3.135-3.937 4.734-6.864 4.734-8.777 0-3.288-2.317-5.538-5.539-5.538z", fillRule: "evenodd" }));
});

var _extends$g = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$f(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$6 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$f(_ref, ["styles"]);

  return React.createElement("svg", _extends$g({ height: "72", viewBox: "0 0 96 72", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M55.384 0c7.252 0 12.924 5.507 12.924 12.923 0 4.15-2.197 8.172-6.464 13.521C58.67 30.04 54.828 33 50.343 35.323c.03.177.06.356.092.536.567 5.4-.2 11.844-1.967 17.478l12.266 6.133c8.659 4.349 11.26 5.146 18.65 5.146 2.235 0 5.956-.998 9.231-2.369V14.804c-4.32 1.455-8.43 1.811-14.769 1.811V9.231c7.784 0 11.281-.538 16.81-3.303C93.111 4.701 96 6.486 96 9.231v55.385a3.692 3.692 0 0 1-2.036 3.3C89.387 70.212 83.43 72 79.384 72c-8.74 0-12.368-1.111-21.958-5.928l-11.847-5.925a21.98 21.98 0 0 1-1.943 2.899C40.122 68.048 34.407 72 29.538 72c-8.5 0-14.77-6.264-14.77-12.917 0-7.308 4.95-12.929 14.77-12.929 2.16 0 4.382.495 6.821 1.408 1.625.607 3.18 1.324 5.39 2.436 1.108-3.922 1.665-8.256 1.469-11.934-4.806 1.073-9.839.601-15.006-1.387l2.652-6.892c4.026 1.55 7.742 1.854 11.258.948-1.003-6.645-1.507-11.958-1.507-15.97C40.615 5.948 47.495 0 55.385 0zM1.082 8.465c5.22-5.219 18.16-6.406 31.282-2.794l-1.96 7.12c-9.758-2.686-19.119-2.182-23.02.086v57.277H0V11.076c0-.98.39-1.918 1.082-2.61zM29.538 53.54c-5.518 0-7.384 2.12-7.384 5.544 0 2.573 2.96 5.533 7.384 5.533 2.047 0 5.789-2.588 8.193-5.999.422-.526.825-1.119 1.208-1.765l-.47-.238c-2.012-1.013-3.372-1.64-4.698-2.136-1.678-.628-3.075-.94-4.233-.94zM55.384 7.385c-4.03 0-7.384 2.9-7.384 7.377 0 3.178.369 7.42 1.12 12.783 2.746-1.67 5.11-3.632 7.069-5.845 3.135-3.937 4.734-6.864 4.734-8.777 0-3.288-2.317-5.538-5.539-5.538z", fillRule: "evenodd" }));
});

var getMoneyNote = getThemeIcon(VMIcon$5, GenericIcon$6);

var _extends$h = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$g(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$6 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$g(_ref, ["styles"]);

  return React.createElement("svg", _extends$h({ width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M28.82 5.3l-6.595 6.6-.636.64.05.9c.11 1.88.313 5.24.49 8.14.153 2.58.3 5 .31 5.2.005.16.007.18-.125.34-.296.36-.848.98-1.312 1.48-.72-1.94-2.236-6.06-3.072-8.36l-1.075-2.96-2.224 2.24-4.09 3.92-.567.58-.018.8c-.014.64-.01 1.8-.008 2.82.002.64.002 1.2 0 1.58-.054-.1-.104-.18-.16-.26-.824-1.32-1.964-3.14-2.312-3.7l-.256-.42-.417-.26c-1.47-.88-3.08-1.9-4.114-2.56h1.493c.782.02 1.672.04 2.352.04.258 0 .492-.02.676-.02l.807-.02.568-.56 3.938-4.08 2.216-2.22-2.943-1.08c-2.21-.8-6.444-2.4-8.424-3.14.508-.46 1.12-1.02 1.478-1.32.1-.08.177-.12.23-.12h.07c.223 0 2.967.18 5.62.36 2.815.18 5.993.4 7.8.5l.903.06 7.234-7.24C27.723 2.16 28.72 2 29.225 2c.328 0 .558.06.678.12.142.38.336 1.76-1.082 3.18zM31.336.68C30.95.3 30.173 0 29.225 0 28.04 0 26.59.46 25.29 1.76l-6.593 6.6C14.983 8.12 5.47 7.5 5.233 7.48H5.08c-.32 0-.875.06-1.505.6-.742.6-2.288 2.06-2.288 2.06-.372.38-.56.84-.516 1.28.03.26.173.74.817 1 .394.14 6.636 2.48 9.518 3.54l-3.938 4.08h-.632c-1.202 0-3.062-.04-3.808-.04h-.234c-.228.02-.696-.1-1.936.94l-.088.08c-.373.38-.46.74-.47 1-.007.24.06.6.427.9.218.18 3.032 1.98 5.338 3.38.554.9 3.1 4.96 3.232 5.18.194.32.51.52.89.52h.032c.367 0 .745-.18 1.117-.54 1.048-1.22.904-1.74.91-1.96.016-.66-.012-3.5.012-4.64l4.087-3.92c1.046 2.86 3.33 9.06 3.484 9.46.253.64.733.78.997.8.044.02.088.02.13.02.396 0 .806-.2 1.14-.54 0 0 1.448-1.52 2.066-2.28.616-.74.59-1.38.58-1.68-.006-.22-.586-9.7-.802-13.4l6.597-6.6c2.338-2.36 1.966-5.18 1.098-6.04z" }));
});

var _extends$i = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$h(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$7 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$h(_ref, ["styles"]);

  return React.createElement("svg", _extends$i({ width: "32", height: "32", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M28.82 5.3l-6.595 6.6-.636.64.05.9c.11 1.88.313 5.24.49 8.14.153 2.58.3 5 .31 5.2.005.16.007.18-.125.34-.296.36-.848.98-1.312 1.48-.72-1.94-2.236-6.06-3.072-8.36l-1.075-2.96-2.224 2.24-4.09 3.92-.567.58-.018.8c-.014.64-.01 1.8-.008 2.82.002.64.002 1.2 0 1.58-.054-.1-.104-.18-.16-.26-.824-1.32-1.964-3.14-2.312-3.7l-.256-.42-.417-.26c-1.47-.88-3.08-1.9-4.114-2.56h1.493c.782.02 1.672.04 2.352.04.258 0 .492-.02.676-.02l.807-.02.568-.56 3.938-4.08 2.216-2.22-2.943-1.08c-2.21-.8-6.444-2.4-8.424-3.14.508-.46 1.12-1.02 1.478-1.32.1-.08.177-.12.23-.12h.07c.223 0 2.967.18 5.62.36 2.815.18 5.993.4 7.8.5l.903.06 7.234-7.24C27.723 2.16 28.72 2 29.225 2c.328 0 .558.06.678.12.142.38.336 1.76-1.082 3.18zM31.336.68C30.95.3 30.173 0 29.225 0 28.04 0 26.59.46 25.29 1.76l-6.593 6.6C14.983 8.12 5.47 7.5 5.233 7.48H5.08c-.32 0-.875.06-1.505.6-.742.6-2.288 2.06-2.288 2.06-.372.38-.56.84-.516 1.28.03.26.173.74.817 1 .394.14 6.636 2.48 9.518 3.54l-3.938 4.08h-.632c-1.202 0-3.062-.04-3.808-.04h-.234c-.228.02-.696-.1-1.936.94l-.088.08c-.373.38-.46.74-.47 1-.007.24.06.6.427.9.218.18 3.032 1.98 5.338 3.38.554.9 3.1 4.96 3.232 5.18.194.32.51.52.89.52h.032c.367 0 .745-.18 1.117-.54 1.048-1.22.904-1.74.91-1.96.016-.66-.012-3.5.012-4.64l4.087-3.92c1.046 2.86 3.33 9.06 3.484 9.46.253.64.733.78.997.8.044.02.088.02.13.02.396 0 .806-.2 1.14-.54 0 0 1.448-1.52 2.066-2.28.616-.74.59-1.38.58-1.68-.006-.22-.586-9.7-.802-13.4l6.597-6.6c2.338-2.36 1.966-5.18 1.098-6.04z" }));
});

var getPlaneOutlineLarge = getThemeIcon(VMIcon$6, GenericIcon$7);

var _extends$j = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$i(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$7 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$i(_ref, ["styles"]);

  return React.createElement("svg", _extends$j({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M9.68 50.354A38.428 38.428 0 0 0 62.686 85.88l2.918 7.103a45.822 45.822 0 0 1-17.524 3.45C22.642 96.406 2.028 75.792 2 50.354zM85.164 4l9.27 9.27-5.43 5.43-1.921-1.92-3.82 3.82A46.033 46.033 0 0 1 94.16 50.354a45.66 45.66 0 0 1-8.62 26.88h8.62v7.68H71.12v-23.04h7.68l.001 11.523A38.401 38.401 0 0 0 48.08 11.954 38.127 38.127 0 0 0 15.331 30.29c-1.736 4.444-2.073 7.733-.948 9.278 2.448 3.364 13.54 2.61 20.167 2.156 1.384-.165 2.936-.281 4.462-.394.81-.06 1.596-.121 2.355-.184l-.566-5.68a10.757 10.757 0 0 1 2.832-8.296 11.3 11.3 0 0 1 8.115-3.69c5.556.104 9.981 4.685 9.892 10.242a12.68 12.68 0 0 1-4.785 9.663l-.405.35a19.332 19.332 0 0 1-6.739 3.693l.207 2.081c.028.281.051.562.07.844h5.772v7.68h-6.456c-.062.247-.127.493-.196.739l6.22 4.185a14.134 14.134 0 0 0 8.82 2.763l-.007 7.68a21.747 21.747 0 0 1-13.02-4.02l-5.31-3.574c-.217.32-.446.638-.678.95a13.15 13.15 0 0 1-10.077 6.633 9.968 9.968 0 0 1-11.276-8.224 10.15 10.15 0 0 1 2.048-8.122 10.624 10.624 0 0 1 8.44-4.103c2.718.077 5.393.695 7.868 1.819.244-1.484.29-2.993.139-4.489l-.146-1.485c-.855.079-1.703.139-2.55.203-1.418.105-2.861.21-4.324.382-12.623.855-22.504 1.009-27.079-5.284-2.88-3.956-2.835-9.498.139-16.938l.278-.56C19.269 8.856 40.46.416 60.407 5.955a45.983 45.983 0 0 1 17.43 9.215l3.816-3.819-1.92-1.92zm-50.88 56.621a2.93 2.93 0 0 0-2.314 1.035 2.886 2.886 0 0 0-.69 1.879c.255 1.286.799 2.46 3.214 2.194 1.826-.116 3.382-1.924 4.38-3.42.112-.15.225-.304.333-.454a13.011 13.011 0 0 0-4.923-1.234zm17.464-29.46a3.69 3.69 0 0 0-2.468 1.215 3.04 3.04 0 0 0-.829 2.397l.469 4.736a11.315 11.315 0 0 0 2.565-1.635l.315-.27a4.952 4.952 0 0 0 2.16-3.881 2.409 2.409 0 0 0-2.212-2.562z" }));
});

var _extends$k = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$j(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$8 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$j(_ref, ["styles"]);

  return React.createElement("svg", _extends$k({ xmlns: "http://www.w3.org/2000/svg", width: "64", height: "64", viewBox: "0 0 64 64" }, props), React.createElement("path", { d: "M32.5 29.54c-13.577 0-24.583-5.509-24.583-12.307 0-6.796 11.006-12.308 24.583-12.308 13.575 0 24.583 5.512 24.583 12.308 0 6.798-11.008 12.307-24.583 12.307m0 9.846c-13.577 0-24.583-5.51-24.583-12.308 0-.1.027-.199.032-.297 5.285 4.63 14.305 7.682 24.551 7.682 10.246 0 19.266-3.053 24.551-7.685.005.101.032.2.032.3 0 6.799-11.008 12.308-24.583 12.308m0 9.848c-13.577 0-24.583-5.511-24.583-12.31 0-.1.027-.2.032-.3 5.285 4.63 14.305 7.684 24.551 7.684 10.246 0 19.264-3.054 24.551-7.684.005.1.032.2.032.3 0 6.799-11.008 12.31-24.583 12.31m0 9.843c-13.577 0-24.583-5.509-24.583-12.307 0-.101.027-.2.032-.3 5.285 4.632 14.305 7.684 24.551 7.684 10.246 0 19.264-3.052 24.551-7.684.005.1.032.199.032.3 0 6.798-11.008 12.307-24.583 12.307m28.261-36.922c.796-1.56 1.239-3.21 1.239-4.922C62 7.719 48.791 0 32.5 0 16.206 0 3 7.72 3 17.233c0 1.713.442 3.362 1.239 4.922C3.443 23.716 3 25.368 3 27.078c0 1.711.442 3.363 1.239 4.923C3.443 33.561 3 35.213 3 36.924c0 1.71.442 3.362 1.239 4.923C3.443 43.407 3 45.059 3 46.77 3 56.283 16.206 64 32.5 64 48.791 64 62 56.283 62 46.77c0-1.71-.443-3.362-1.239-4.923.796-1.56 1.239-3.212 1.239-4.923 0-1.71-.443-3.362-1.239-4.923.796-1.56 1.239-3.212 1.239-4.923 0-1.71-.443-3.362-1.239-4.923" }));
});

var getTimeIsMoney = getThemeIcon(VMIcon$7, GenericIcon$8);

var _extends$l = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$k(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$8 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$k(_ref, ["styles"]);

  return React.createElement("svg", _extends$l({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M8 4v80h88v8H4a4 4 0 0 1-3.973-3.534L0 88V4zm83.982 8c2.06 0 3.759 1.533 3.991 3.507l.027.463v19.85h-8.035V25.157L84.6 28.505l-7.642 7.607c-2.559 2.554-6.676 5.13-10.888 6.809l-.392.148-.216.543c-1.4 3.384-3.437 6.768-5.59 9.304l-.721.812-.5.498-.184.162-10.45 10.322a4.054 4.054 0 0 1-5.303.33l-.379-.33-8.122-8.032L16.682 74 11 68.386l20.369-20.128a4.054 4.054 0 0 1 5.301-.332l.379.33 8.129 8.03 8.244-8.135.505-.579a24.99 24.99 0 0 0 2.018-2.87h-.007a11.314 11.314 0 0 1-1.634-.31l-.612-.175-1.589-.59c-4.95-1.986-7.814-7.131-6.819-12.527a10.633 10.633 0 0 1 2.955-5.19c1.44-1.427 3.243-2.445 5.467-3.002 5.057-.953 10.087 1.62 12.21 6.083l.632 1.454c.403.93.66 1.924.784 3.003 1.29-.77 2.452-1.598 3.36-2.4l.561-.526 7.635-7.601.011-.01 2.987-2.971h-9.991V12zM55.84 30.615l-.381.038a3.41 3.41 0 0 0-1.575.908c-.385.37-.655.84-.736 1.156-.247 1.348.397 2.684 1.51 3.332l.387.19 1.193.443.29.01c.548.023 1.151.017 1.737-.013l.99-.08.082-.468v-.427l.023-.003.027-.454c.02-.594-.034-1.073-.137-1.43l-.088-.244-.404-.938c-.505-1.26-1.761-2.042-2.918-2.02z" }));
});

var _extends$m = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$l(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$9 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$l(_ref, ["styles"]);

  return React.createElement("svg", _extends$m({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M14.5 14.618h-13c-.276 0-.5-.21-.5-.47v-3.52l3.849-3.243 3.83 2.47.058.053.01-.01.016.01.732-.69-.015-.01L15 4.014v10.134c0 .26-.223.471-.5.471zM1 1.912c0-.26.224-.47.5-.47h13c.277 0 .5.21.5.47v.722L8.611 8.648l-3.79-2.443-.058-.054-.011.01-.015-.01-.224.21L1 9.322v-7.41zM15 .5H1c-.552 0-1 .422-1 .942v13.176c0 .52.448.94 1 .94h14c.552 0 1-.42 1-.94V1.442c0-.52-.448-.942-1-.942z" }));
});

var getUsageOutlineLarge = getThemeIcon(VMIcon$8, GenericIcon$9);

var _extends$n = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$m(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var VMIcon$9 = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$m(_ref, ["styles"]);

  return React.createElement("svg", _extends$n({ height: "96", viewBox: "0 0 96 96", width: "96", xmlns: "http://www.w3.org/2000/svg" }, props), React.createElement("path", { d: "M54.982.39l12.27 14.141 8.803-1.832 5.177 17.258h9.15v22.871a18.92 18.92 0 0 1-3.187 10.527l-.084.13a18.981 18.981 0 0 1 3.272 10.652V96H17.105c-6.341-.007-11.48-5.146-11.488-11.488v-39.32h8v39.32A3.493 3.493 0 0 0 17.105 88h65.278V74.137c0-1.389-.264-2.765-.778-4.055a19.31 19.31 0 0 1-11.128 3.45 10.553 10.553 0 1 1-.008-21.106 15.997 15.997 0 0 1 11.02 4.746 10.95 10.95 0 0 0 .894-4.344V37.957H14.299a8.68 8.68 0 1 1 0-17.36h16.858zM70.46 60.427a2.553 2.553 0 0 0 .01 5.105c2.23.019 4.415-.623 6.281-1.843a8.763 8.763 0 0 0-6.291-3.262zm2.42-30.47L70.5 22.028l-38.14 7.93zm-52.757 0l1.603-1.36-7.426.002a.68.68 0 1 0 0 1.359zM54.123 11.61l-8.826 7.485 12.982-2.7z" }));
});

var _extends$o = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties$n(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}
var GenericIcon$a = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties$n(_ref, ["styles"]);

  return React.createElement("svg", _extends$o({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props), React.createElement("path", { d: "M12 10h1V9h-1v1zm.492-2.008a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM15 14.502a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V5.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v9zM1 3V1.5a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 .5.5v2.495H1V3zm14 1h-2.005V1.733C12.995.776 12.26 0 11.354 0H1.639C.811 0 .133.652.022 1.496H0V15a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1z" }));
});

var getWalletOutlineLarge = getThemeIcon(VMIcon$9, GenericIcon$a);

var main$4 = "PromoButton.js";
var variants$1 = ["BusinessBanking", "CreditCards", "CurrentAccounts", "Insurance", "International", "Loans", "MoneyManagement", "Mortgages", "PrivateBanking", "RiskManagement", "Savings"];
var packageJson$4 = {
	main: main$4,
	variants: variants$1,
	"component-id": null,
	"component-life-cycle": "active",
	"is-bespoke": false
};

var _templateObject$a = taggedTemplateLiteral(['\n\talign-items: center;\n\tbackground-color: ', ';\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\tmin-width: 100%;\n\tpadding: ', '\n\t\t', ';\n\ttransition: all 0.15s;\n\ttext-decoration: none;\n\twidth: 100%;\n\n\t:hover {\n\t\tbackground-color: ', ';\n\t\tcolor: ', ';\n\n\t\tsvg {\n\t\t\tfill: ', ';\n\t\t}\n\t}\n'], ['\n\talign-items: center;\n\tbackground-color: ', ';\n\tborder: 2px solid ', ';\n\tborder-radius: ', ';\n\tbox-sizing: border-box;\n\tcolor: ', ';\n\tcursor: pointer;\n\tdisplay: inline-flex;\n\tmin-width: 100%;\n\tpadding: ', '\n\t\t', ';\n\ttransition: all 0.15s;\n\ttext-decoration: none;\n\twidth: 100%;\n\n\t:hover {\n\t\tbackground-color: ', ';\n\t\tcolor: ', ';\n\n\t\tsvg {\n\t\t\tfill: ', ';\n\t\t}\n\t}\n']),
    _templateObject2$7 = taggedTemplateLiteral(['\n\tdisplay: flex;\n\tsvg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n'], ['\n\tdisplay: flex;\n\tsvg {\n\t\tfill: ', ';\n\t\theight: ', ';\n\t\tmargin-right: ', ';\n\t\twidth: ', ';\n\t}\n']),
    _templateObject3$4 = taggedTemplateLiteral(['\n\tfont-family: ', ';\n\tfont-size: ', ';\n\tfont-weight: bold;\n\tline-height: 1.5;\n'], ['\n\tfont-family: ', ';\n\tfont-size: ', ';\n\tfont-weight: bold;\n\tline-height: 1.5;\n']);

var StyledButton$2 = styled('button')(_templateObject$a, colours.generalPalette.white, function (props) {
	return props.theme.colours.primary;
}, function (props) {
	return props.theme.borderRadiusLarger;
}, function (props) {
	return props.theme.colours.primary;
}, function (props) {
	return props.theme.isCompact ? '' + spacing.SINGLE : '' + spacing.TRIPLE;
}, INTERNET_BANKING_CSS_OVERRIDE, function (props) {
	return props.theme.colours.primary;
}, colours.generalPalette.white, colours.generalPalette.white);

var StyledIconWrapper$1 = styled('div')(_templateObject2$7, function (props) {
	return props.theme.colours.primary;
}, function (props) {
	return props.theme.isCompact ? '20px' : '40px';
}, spacing.DOUBLE, function (props) {
	return props.theme.isCompact ? '20px' : '40px';
});

var StyledLabelText = styled('span')(_templateObject3$4, function (props) {
	return props.theme.fonts.display.bold;
}, function (props) {
	return props.theme.isCompact ? '14px' : '18px';
});

var BasePromoButton = function BasePromoButton(_ref) {
	var onClick = _ref.onClick,
	    icon = _ref.icon,
	    labelText = _ref.labelText,
	    dataTestId = _ref['data-test-id'];
	return React.createElement(
		StyledButton$2,
		{ onClick: onClick, 'data-test-id': dataTestId + '-button' },
		React.createElement(
			StyledIconWrapper$1,
			{ 'data-test-id': dataTestId + '-icon' },
			icon
		),
		React.createElement(
			StyledLabelText,
			{ 'data-test-id': dataTestId + '-label' },
			labelText
		)
	);
};

var baseProps$1 = {
	/** Callback function triggered on click. */
	onClick: PropTypes.func.isRequired,
	/** Button text. */
	labelText: PropTypes.string.isRequired,
	/** Partial Data attribute for automation test purposes - appended by -button, -icon, -label. */
	'data-test-id': PropTypes.string
};

BasePromoButton.propTypes = _extends({}, baseProps$1, {
	/** Icon displayed on the left side of the button. */
	icon: PropTypes.node.isRequired
});

var UnwrappedBusinessBanking = function UnwrappedBusinessBanking(_ref2) {
	var onClick = _ref2.onClick,
	    labelText = _ref2.labelText,
	    theme = _ref2.theme,
	    dataTestId = _ref2['data-test-id'];

	var BriefcaseOutlineLargeIcon = getBriefcaseOutlineLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4 },
		React.createElement(BasePromoButton, {
			icon: React.createElement(BriefcaseOutlineLargeIcon, null),
			labelText: labelText,
			onClick: onClick,
			'data-test-id': dataTestId
		})
	);
};

UnwrappedBusinessBanking.propTypes = _extends({}, baseProps$1);

UnwrappedBusinessBanking.defaultProps = {
	'data-test-id': 'business-banking-promobutton'
};

var BusinessBanking = withTheme(UnwrappedBusinessBanking);

var UnwrappedCreditCards = function UnwrappedCreditCards(_ref3) {
	var onClick = _ref3.onClick,
	    labelText = _ref3.labelText,
	    theme = _ref3.theme,
	    dataTestId = _ref3['data-test-id'];

	var CreditCardOutlineLargeIcon = getCreditCardOutlineLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4 },
		React.createElement(BasePromoButton, {
			icon: React.createElement(CreditCardOutlineLargeIcon, null),
			labelText: labelText,
			onClick: onClick,
			'data-test-id': dataTestId
		})
	);
};

UnwrappedCreditCards.propTypes = _extends({}, baseProps$1);

UnwrappedCreditCards.defaultProps = {
	'data-test-id': 'credit-cards-promobutton'
};

var CreditCards = withTheme(UnwrappedCreditCards);

var UnwrappedCurrentAccounts = function UnwrappedCurrentAccounts(_ref4) {
	var onClick = _ref4.onClick,
	    labelText = _ref4.labelText,
	    theme = _ref4.theme,
	    dataTestId = _ref4['data-test-id'];

	var MoneyNoteIcon = getMoneyNote(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4 },
		React.createElement(BasePromoButton, { icon: React.createElement(MoneyNoteIcon, null), labelText: labelText, onClick: onClick, 'data-test-id': dataTestId })
	);
};

UnwrappedCurrentAccounts.propTypes = _extends({}, baseProps$1);

UnwrappedCurrentAccounts.defaultProps = {
	'data-test-id': 'current-accounts-promobutton'
};

var CurrentAccounts = withTheme(UnwrappedCurrentAccounts);

var getHealth = getThemeIcon(VMHealthIcon, CYBGPlusIcon);
var UnwrappedInsurance = function UnwrappedInsurance(_ref5) {
	var onClick = _ref5.onClick,
	    labelText = _ref5.labelText,
	    theme = _ref5.theme,
	    dataTestId = _ref5['data-test-id'];

	var HealthIcon = getHealth(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4 },
		React.createElement(BasePromoButton, { icon: React.createElement(HealthIcon, null), labelText: labelText, onClick: onClick, 'data-test-id': dataTestId })
	);
};

UnwrappedInsurance.propTypes = _extends({}, baseProps$1);

UnwrappedInsurance.defaultProps = {
	'data-test-id': 'insurance-promobutton'
};

var Insurance = withTheme(UnwrappedInsurance);

var UnwrappedInternational = function UnwrappedInternational(_ref6) {
	var onClick = _ref6.onClick,
	    labelText = _ref6.labelText,
	    theme = _ref6.theme,
	    dataTestId = _ref6['data-test-id'];

	var PlaneOutlineLarge = getPlaneOutlineLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4 },
		React.createElement(BasePromoButton, { icon: React.createElement(PlaneOutlineLarge, null), labelText: labelText, onClick: onClick, 'data-test-id': dataTestId })
	);
};

UnwrappedInternational.propTypes = _extends({}, baseProps$1);

UnwrappedInternational.defaultProps = {
	'data-test-id': 'international-promobutton'
};

var International = withTheme(UnwrappedInternational);

var UnwrappedLoans = function UnwrappedLoans(_ref7) {
	var onClick = _ref7.onClick,
	    labelText = _ref7.labelText,
	    theme = _ref7.theme,
	    dataTestId = _ref7['data-test-id'];

	var TimeIsMoneyIcon = getTimeIsMoney(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4 },
		React.createElement(BasePromoButton, { icon: React.createElement(TimeIsMoneyIcon, null), labelText: labelText, onClick: onClick, 'data-test-id': dataTestId })
	);
};

UnwrappedLoans.propTypes = _extends({}, baseProps$1);

UnwrappedLoans.defaultProps = {
	'data-test-id': 'loans-promobutton'
};

var Loans = withTheme(UnwrappedLoans);

var UnwrappedMortgages = function UnwrappedMortgages(_ref8) {
	var onClick = _ref8.onClick,
	    labelText = _ref8.labelText,
	    theme = _ref8.theme,
	    dataTestId = _ref8['data-test-id'];

	var BuildingOutlineLargeIcon = getBuildingOutlineLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4 },
		React.createElement(BasePromoButton, {
			icon: React.createElement(BuildingOutlineLargeIcon, null),
			labelText: labelText,
			onClick: onClick,
			'data-test-id': dataTestId
		})
	);
};

UnwrappedMortgages.propTypes = _extends({}, baseProps$1);

UnwrappedMortgages.defaultProps = {
	'data-test-id': 'mortgages-promobutton'
};

var Mortgages = withTheme(UnwrappedMortgages);

var UnwrappedMoneyManagement = function UnwrappedMoneyManagement(_ref9) {
	var onClick = _ref9.onClick,
	    labelText = _ref9.labelText,
	    theme = _ref9.theme,
	    dataTestId = _ref9['data-test-id'];

	var UsageOutlineLarge = getUsageOutlineLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4 },
		React.createElement(BasePromoButton, { icon: React.createElement(UsageOutlineLarge, null), labelText: labelText, onClick: onClick, 'data-test-id': dataTestId })
	);
};

UnwrappedMoneyManagement.propTypes = _extends({}, baseProps$1);

UnwrappedMoneyManagement.defaultProps = {
	'data-test-id': 'money-management-promobutton'
};

var MoneyManagement = withTheme(UnwrappedMoneyManagement);

var UnwrappedPrivateBanking = function UnwrappedPrivateBanking(_ref10) {
	var onClick = _ref10.onClick,
	    labelText = _ref10.labelText,
	    theme = _ref10.theme,
	    dataTestId = _ref10['data-test-id'];

	var LockOutlineLargeIcon = getLockOutlineLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4 },
		React.createElement(BasePromoButton, {
			icon: React.createElement(LockOutlineLargeIcon, null),
			labelText: labelText,
			onClick: onClick,
			'data-test-id': dataTestId
		})
	);
};

UnwrappedPrivateBanking.propTypes = _extends({}, baseProps$1);

UnwrappedPrivateBanking.defaultProps = {
	'data-test-id': 'private-banking-promobutton'
};

var PrivateBanking = withTheme(UnwrappedPrivateBanking);

var UnwrappedSavings = function UnwrappedSavings(_ref11) {
	var onClick = _ref11.onClick,
	    labelText = _ref11.labelText,
	    theme = _ref11.theme,
	    dataTestId = _ref11['data-test-id'];

	var WalletOutlineLargeIcon = getWalletOutlineLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4 },
		React.createElement(BasePromoButton, {
			icon: React.createElement(WalletOutlineLargeIcon, null),
			labelText: labelText,
			onClick: onClick,
			'data-test-id': dataTestId
		})
	);
};

UnwrappedSavings.propTypes = _extends({}, baseProps$1);

UnwrappedSavings.defaultProps = {
	'data-test-id': 'savings-promobutton'
};

var Savings = withTheme(UnwrappedSavings);

var UnwrappedRiskManagement = function UnwrappedRiskManagement(_ref12) {
	var onClick = _ref12.onClick,
	    labelText = _ref12.labelText,
	    theme = _ref12.theme,
	    dataTestId = _ref12['data-test-id'];

	var ClipboardTickOutlineLarge = getClipboardTickOutlineLarge(theme.name);
	return React.createElement(
		InternalComponentFrame,
		{ packageJson: packageJson$4 },
		React.createElement(BasePromoButton, {
			icon: React.createElement(ClipboardTickOutlineLarge, null),
			labelText: labelText,
			onClick: onClick,
			'data-test-id': dataTestId
		})
	);
};

UnwrappedRiskManagement.propTypes = _extends({}, baseProps$1);

UnwrappedRiskManagement.defaultProps = {
	'data-test-id': 'risk-management-promobutton'
};

var RiskManagement = withTheme(UnwrappedRiskManagement);

var PromoButton = {
	BusinessBanking: BusinessBanking,
	CreditCards: CreditCards,
	CurrentAccounts: CurrentAccounts,
	Insurance: Insurance,
	International: International,
	Loans: Loans,
	MoneyManagement: MoneyManagement,
	Mortgages: Mortgages,
	PrivateBanking: PrivateBanking,
	RiskManagement: RiskManagement,
	Savings: Savings
};

export { NavigationButton, NavigationButtonGroup, PromoButton };
